import React, { Component } from "react";
import "./style.scss";
import {
  NormalButton,
  NormalInput,
  NormalSelect,
  InputSearch,
  NormalModal,
  TableWrapper,
  NormalTextarea,
  NormalCheckbox,
  NormalRadio,
  NormalMultiSelect,
  SearchInputKeyboard,
} from "component/common";
import { dateFormat } from "service/helperFunctions";
import _ from "lodash";
import { history } from "helpers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IoSearchCircle } from "react-icons/io5";
import { AiOutlineSearch } from "react-icons/ai";

import {
  getCommonApi,
  updateForm,
  commonDeleteApi,
  commonPatchApi,
  commonCreateApi,
  commonUpdateApi,
} from "redux/actions/common";
import SimpleReactValidator from "simple-react-validator";
import {
  Treatment,
  Payment,
  EditCart,
  TreatmentDone,
  PackageCart,
} from "./cart/index";
import closeIcon from "assets/images/close.png";

import add from "assets/images/add.png";
import minus from "assets/images/minus.png";
// import Discount from './cart/discount';
import { EditDiscount } from "./cart/editDiscount";
import { Topup } from "./topup/topup";
import { Toast } from "service/toast";
import { ProductDetailsPopup } from "./cart/productDetailsPopup";
import { ItemDiscountPopup } from "./cart/ItemDiscountPopup";
import { ItemStatusPopup } from "./cart/itemStatusPopup";
import { StaffSelectionPopup } from "./cart/staffSelectionPopup";
import { CoursePopup } from "./cart/CoursePopup";
import { PrepaidPopup } from "./cart/PrepaidPopup";
import packageIcon from "assets/images/packing-icon.png";
import { withTranslation } from "react-i18next";

import tdIcon from "assets/images/tdIcon.png";
import topupIcon from "assets/images/topupIcon.png";
import payIcon from "assets/images/app-icons/0.png";
import billOpsIcon from "assets/images/billOpsIcon.png";
import profileIcon from "assets/images/profileIcon.png";
import exchangeIcon from "assets/images/exchangeIcon.png";
import clearAllIcon from "assets/images/clearAllIcon.png";
import checkoutIcon from "assets/images/checkoutIcon.png";
import TransactionIcon from "assets/images/TransactionIcon.png";
import shareIcon from "assets/images/shareicon.png";
import { StaffList } from "../Cart/cart/StaffList";
import { CombineTopup } from "./CombineTopup/index.js";
import { CredentialConfirmation } from "./credentialConfirmation";
import { debounce } from "service/Helper";
import { getTreatementPageTrack } from "redux/actions/treatement";
import NumPad from "react-numpad";
import { InputKeyboard } from "component/common/InputKeyboard";
import { NumPadKeyboard } from "component/common/NumPadKeyboard";
import Switch from "react-switch";
import { Modal, ModalBody } from "reactstrap";
import { NewSelectTreatment } from "../NewAppointment/NewCreateAppointment/NewSelectTreatment";
import { StudioATreatment } from "../NewAppointment/NewCreateAppointment/StudioAppointment";
import { forEach } from "jszip";
import { ShareModal } from "./sharePackage";
let deviceWidth = window.innerWidth;
export class CartNewClass extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      isOpen: false,
      currentIndex: -1,
      cartList: [],
      cartData: {},
      formFields: {
        custId: "",
        custName: "",
        cust_dob: "",
        IsBirthdayMonth: "",
        IsCustomerClassExpired: "",
        classexpired: "",
        classexpiredstatus: "",
        cust_class: ""
      },
      shareCustomer: "",
      selectedPackage: "",
      outletList: [{ label: "name", value: "id" }],
      isOpenPayment: false,
      isCreateAppointment: false,
      isOpenEditcart: false,
      isOpenPackage: false,
      isOpenCustomer: false,
      showBirthdayPopup: false,
      showCustomerClassExpiredPopup: false,
      isOpenEditDisc: false,
      isOpenTreatmentDone: false,
      isOpenModal: false,
      headerDetails: [
        {
          label: "",
          width: "20px",
          selectAll: true,
          selectAllCheck: false,
          checkboxChange: (e) => this.handleSelectAllCheckbox(e),
        },
        { label: "", width: "30px" },
        {
          label: "Item",
          sortKey: false,
          width: "135px",
          className: "cursor-pointer border border-white text-warning ",
          dblclickFunc: () => this.handleItemHeaderDblClick(true),
        },
        {
          label: "Qty",
          width:
            this.props.tokenDetails.autotdforalacarte &&
            deviceWidth > 1000 &&
            deviceWidth <= 1250
              ? "60px"
              : "80px",
          divClass: "justify-content-center text-center",
        },
        {
          label: "Unit Price",
          sortKey: false,
          width:
            this.props.tokenDetails.autotdforalacarte &&
            deviceWidth > 1000 &&
            deviceWidth <= 1250
              ? "80px"
              : "100px",
          divClass: "justify-content-center text-center",
        },
        {
          label: "Disc $",
          sortKey: false,
          width: "58px",
          divClass: "justify-content-end text-right",
        },
        {
          label: "D/Price",
          sortKey: false,
          width: "70px",
          divClass: "justify-content-end text-right",
          className:
            this.props.tokenDetails.autotdforalacarte &&
            deviceWidth > 1000 &&
            deviceWidth <= 1250 &&
            "HideDpriceHeader",
        },
        {
          label: "Amt",
          sortKey: false,
          width: "72px",
          divClass: "justify-content-end text-right",
        },
        {
          label: "Deposit",
          sortKey: false,
          width: "72px",
          divClass: "justify-content-end text-right",
          className: `${this.props.tokenDetails?.ipadkey && "d-none"}`,
        },

        {
          label: "S.Staff",
          sortKey: false,
          width: "90px",
          className: "cursor-pointer border border-white text-warning",
          dblclickFunc: () => this.handleStaffSelectionHeaderClick(true),
        },
        {
          label: "T.Staff",
          sortKey: false,
          width: "90px",
          dblclickFunc: () => {},
        },
        {
          label: "Item Status",
          sortKey: false,
          width: "90px",
          className: "cursor-pointer border border-white text-warning",
          dblclickFunc: () => this.handleItemStatusHeaderDblClick(true),
        },
      ],
      customerOption: [],
      discountFields: {
        discount_per: "",
        discount_amt: "",
        reason: "",
      },
      editCart: {},
      search: "",
      cartId: "",
      isOpenTopup: false,
      exchangeBalance: 0,
      isOpenExchangePayment: false,
      exchangeRemark: "",
      exchangeBalanceAmount: 0,
      exchangeType: false,
      isOpenProductDetail: false,
      isOpenCourseDetail: false,
      isOpenPrepaidDetail: false,
      isOpenDiscountDetail: false,
      isOpenItemStatusDetail: false,
      isOpenStaffSelectionDetail: false,
      visible: false,
      shareVisible: false,
      settingData: [],
      defaultStaff: [],
      isOpenCombinedTopup: false,
      staffCommonListPopup: false,
      staffList: [],
      meta: {},
      limit: 6,
      selectAll: false,
      staffDeleteCommonListPopup: false,
      availableStaffList: [],
      availstaffmeta: {},
      availstaffpage: "",
      page: "",
      changedItem: "",
      treatmentCheck: false,
      salesCheck: false,
      commonDeposit: "",
      toptoBottom: false,
      is_selectDeposit: "auto",
      isHandleConfirmationDialog: false,
      isLoginConfirmation: false,
      isExchangeConfirmation: false,
      isStaffLoginConfirmation: false,
      user: "",
      pass: "",
      hideDprice: false,
      hideProductSection: false,
      switchChecked: false,
      switchCheckedOff: true,
      deviceWidthCheck: window.innerWidth,
      editSelectedTdUnitPrice: false,
      selectedTdData: {},
      appointmentId: null,
      depositPriceGst: false,
      taxAmount: 0,
      isSharePopup: false,
      shareHeaderDetails: [
        { label: "Name" },
        { label: "Phone" },
        { label: "" },
      ],
      storeShareCustomer: {},
      sharedCustomerList: [],

    };
  }
  componentWillMount = () => {
    // this.getCart();
    window.removeEventListener("resize", this.handleResize);
    this.validator = new SimpleReactValidator({
      element: (message) => (
        <span className="error-message text-danger validNo fs14">
          {message}
        </span>
      ),
      autoForceUpdate: this,
    });
  };

  componentDidMount() {
    // this.handleItemSettings();
    window.addEventListener("resize", this.handleResize);
    window.scrollTo(0, 0);
    if (
      this.props.tokenDetails.autotdforalacarte &&
      deviceWidth > 1000 &&
      deviceWidth <= 1250
    ) {
      this.setState({ hideDprice: this.props.tokenDetails.autotdforalacarte });
      document.getElementsByClassName("HideDpriceHeader")[0].style.display =
        "none";
    }

    if (this.props.tokenDetails?.showpriceincludegst) {
      this.state.headerDetails.splice(1, 0, {
        label: "",
        width: "20px",
        selectAll: true,
        selectAllCheck: false,
        checkboxChange: (e) => this.handleSelectAllTax(e),
      });
    }

    if (this.props.tokenDetails?.sharepackage) {
      this.state.headerDetails.splice(1, 0, {
        label: "",
        width: "20px",
        // selectAll: true,
        // selectAllCheck: false,
        // checkboxChange: (e) => this.handleSelectAllTax(e),
      });
    }

    /*if (this.props.tokenDetails?.sharepackage) {
      this.state.headerDetails.splice(1, 0, {
        label: "",
        width: "20px",
        // selectAll: true,
        // selectAllCheck: false,
        // checkboxChange: (e) => this.handleSelectAllTax(e),
      });
    }*/

    this.getdefaultStaffList();
    let { basicApptDetail, selectedCart, tokenDetails } = this.props;
    console.log(basicApptDetail, "basicAppDetail");
    console.log(selectedCart, "selectCart");
    console.log(tokenDetails, "tokenDetails");
    if (
      this.props.treatmentPageTrack === "true" ||
      tokenDetails?.custname_retaincart
    ) {
      if (basicApptDetail.custId) {
        let { formFields } = this.state;
        formFields["custId"] = basicApptDetail.custId;
        formFields["custName"] = basicApptDetail.custName;
        formFields["cust_refer"] = basicApptDetail.cust_refer;
        formFields["outstanding_amt"] = basicApptDetail.outstanding_amt; //Yoonus customer outstanding_amt

        this.setState({ formFields });
        this.getCart();
        this.props.getTreatementPageTrack("treatementPageTrack", "false");

        // debugger
        if (basicApptDetail?.cust_name && this.props.tokenDetails.ipadkey) {
          this.child.parentDataUpdate(basicApptDetail?.cust_name);
        }
      }
    }

    if (selectedCart) {
    }
  }

  handleResize = () => {
    this.setState({
      deviceWidthCheck: window.innerWidth,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.deviceWidthCheck !== this.state.deviceWidthCheck) {
      // Device width has changed, perform any necessary actions
      this.setState({
        deviceWidthCheck: window.innerWidth,
      });
      console.log("Device width has changed!", this.state.deviceWidthCheck);
    }
  }

  handleItemSettings = async (data) => {
    console.log("handle" + JSON.stringify(data));
    let { formFields } = this.state;
    formFields["custId"] = data.id;
    formFields["custName"] = data.cust_name;
    formFields["cust_refer"] = data.cust_refer;
    formFields["outstanding_amt"] = data.outstanding_amt; //Yoonus customer outstanding_amt
    await this.setState({
      formFields,
      // isOpenCustomer: false,
      search: "",
      customerOption: [],
    });
    await this.props.updateForm("basicApptDetail", formFields);
    console.log(this.props.basicApptDetail, "sdfsadfasdf");
    if (data?.cust_name && this.props.tokenDetails.ipadkey) {
      // debugger
      this.child.parentDataUpdate(data?.cust_name);
    }
    this.getCart();
  };

  getdefaultStaffList = async () => {
    let { defaultStaff } = this.state;
    this.props
      .getCommonApi(`empcartlist/?sales_staff=1&page=1&limit=1000`)
      .then(async (res) => {
        console.log(res, "salesdefaultstaff");
        let salesdefaultStaff = [];
        // salesdefaultStaff.push({ value: "All", label: "All" });
        // this.setState({ salesdefaultStaff });
        let { data, status } = res;
        if (status == 200) {
          if (data.dataList)
            for (let key of data.dataList) {
              salesdefaultStaff.push({ value: key.id, label: key.emp_name });
              if (key.id == Number(this.props.tokenDetails.default_loginid)) {
                defaultStaff.push({
                  value: key.id,
                  label: key.emp_name,
                });
                await this.setState({
                  defaultStaff,
                });
              }
            }
          await this.setState({ salesdefaultStaff });
        }
      });
  };

  getCart = () => {
    let { productCard, cartData, headerDetails, formFields } = this.state;
    let { basicApptDetail } = this.props;
    // this.props.getCommonApi(`itemcart/Check/?sitecodeid=${selected_cstomer.branchId}&cart_date=${"2020-12-11"}&cust_noid=${selected_cstomer.cust_noid}`).then((key) => {
    //if (cartId== "") {
    //if (1==1) {
    this.props
      .getCommonApi(
        `itemcart/Check/?cart_date=${dateFormat(
          new Date(),
          "yyyy-mm-dd"
        )}&cust_noid=${formFields.custId}`
      )
      .then(async (key) => {
        let { status, data, cart_id, commonDeposit } = key;
        let cartId = cart_id;
        await this.setState({ cartId: cartId, cartData, commonDeposit });
        commonDeposit = "";
        if (status === 200 || status === 204) {
          if (data) {
            this.props
              .getCommonApi(
                `itemcart/?cart_date=${dateFormat(
                  new Date(),
                  "yyyy-mm-dd"
                )}&cust_noid=${formFields.custId}&cart_id=${cart_id}`
              )
              .then(async (res) => {
                cartData = [];

                let { status, data } = res;

                console.log(res, "returndatacartitemlist");
                if (status === 200) {
                  let cartList = Object.assign({}, this.state.cartList);
                  if (data.length > 0) {
                    data.forEach((element) => {
                      let itemData = element;
                      itemData["selected"] = false;
                      itemData["priceincludegst"] = itemData["priceincludegst"] === true ? true : false;                      
                      cartData.push({
                        itemData,
                      });
                    });
                  }

                  cartList = data;
                  headerDetails[0]["selectAllCheck"] = false;
                  this.setState({
                    cartList,
                    cartData: res,
                    cartId,
                    exchangeBalanceAmount: res.balance.slice(1),
                    exchangeType: res.exchange,
                    selectAll: false,
                    headerDetails,
                    commonDeposit: res.deposit_amt,
                    treatmentCheck: false,
                    salesCheck: false,
                  });
                } else if (status === 204) {
                  let cartList = Object.assign({}, this.state.cartList);
                  cartList = [];
                  cartData = {};
                  commonDeposit = "";
                  this.setState({ cartData, cartList, commonDeposit });
                }
              });
          }
        }
      });
    //} else {
    /*
      let { commonDeposit } = this.state;
      let cart_id = cartId;
      commonDeposit = "";

      this.props
      .getCommonApi(
        `itemcart/?cart_date=${dateFormat(
          new Date(),
          "yyyy-mm-dd"
        )}&cust_noid=${formFields.custId}&cart_id=${cart_id}`
      )
      .then(async res => {
        cartData = [];

        let { status, data } = res;

        console.log(res, "returndatacartitemlist");
        if (status === 200) {
          let cartList = Object.assign({}, this.state.cartList);
          if (data.length > 0) {
            data.forEach(element => {
              let itemData = element;
              itemData["selected"] = false;
              cartData.push({
                itemData,
              });
            });
          }

          cartList = data;
          headerDetails[0]["selectAllCheck"] = false;
          this.setState({
            cartList,
            cartData: res,
            cartId,
            exchangeBalanceAmount: res.balance.slice(1),
            exchangeType: res.exchange,
            selectAll: false,
            headerDetails,
            commonDeposit: res.deposit_amt,
            treatmentCheck: false,
            salesCheck: false,
          });
        } else if (status === 204) {
          let cartList = Object.assign({}, this.state.cartList);
          cartList = [];
          cartData = {};
          commonDeposit = "";
          this.setState({ cartData, cartList, commonDeposit });
        }
      });
    */
    //}
  };

  handleCloseDialog = () => {
    this.setState({
      editSelectedTdUnitPrice: false,
    });
  };
  handleAppointmentClose = async () => {
    // await this.props.updateForm("treatmentList", []);
    // //await this.props.updateForm("basicApptDetail", {});
    // await this.props.updateForm("appointmentCustomerDetail", {});
    await this.setState({
      isOpenModal: false,
    });
  };
  handleClick = (key) => {
    if (!this.state.visible) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    if (this.state.visible) {
      let { basicApptDetail } = this.props;
      console.log(basicApptDetail, "beforeClick");
      this.search(basicApptDetail);
    }
    this.setState({ visible: true });
    this.setState((prevState) => ({
      visible: !prevState.visible,
    }));
  };

  handleOutsideClick = (e) => {
    if (this.node != null) {
      if (this.node.contains(e.target)) {
        return;
      }
    }
    this.handleClick();
  };

  getDateTime = (data) => {
    let date = new Date(data);
    date = String(date).split(" ");
    let date1 = date[2] + "th " + date[1] + ", " + date[3];
    let time = date[4].split(":");
    let time1 =
      String(Number(time[0]) > 12 ? Number(time[0]) - 12 : time[0]) +
      ":" +
      time[1] +
      (Number(time[0]) > 12 ? "PM" : "AM");
    return time1 + ", " + date1;
  };

  handleSubmit = (id) => {
    history.push(`/admin/payment/${id}`);
  };

  handleDialog = async () => {
    let {
      isOpenPayment,
      isOpenEditcart,
      isOpenPackage,
      isOpenCustomer,
      isOpenEditDisc,
      isOpenTreatmentDone,
      isOpenTopup,
      isOpenExchangePayment,
      isOpenProductDetail,
      isOpenCourseDetail,
      isOpenPrepaidDetail,
      isOpenDiscountDetail,
      isOpenItemStatusDetail,
      isOpenStaffSelectionDetail,
      isOpenCombinedTopup,
    } = this.state;
    isOpenPayment = false;
    isOpenEditcart = false;
    isOpenPackage = false;
    isOpenCustomer = false;
    isOpenEditDisc = false;
    isOpenTreatmentDone = false;
    isOpenTopup = false;
    isOpenExchangePayment = false;
    isOpenProductDetail = false;
    isOpenCourseDetail = false;
    isOpenPrepaidDetail = false;
    isOpenDiscountDetail = false;
    isOpenItemStatusDetail = false;
    isOpenStaffSelectionDetail = false;
    isOpenCombinedTopup = false;
    await this.setState({
      isOpenPayment,
      isOpenEditcart,
      isOpenPackage,
      isOpenCustomer,
      isOpenEditDisc,
      isOpenTreatmentDone,
      editCart: {},
      isOpenTopup,
      isOpenExchangePayment,
      isOpenProductDetail,
      isOpenCourseDetail,
      isOpenPrepaidDetail,
      isOpenDiscountDetail,
      isOpenItemStatusDetail,
      isOpenStaffSelectionDetail,
      isOpenCombinedTopup,
    });
    this.getCart();
  };

  handlecheckIN = (event) => {
    if (event.key === "Backspace") {
      this.handleClearMethod();
    }
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleIconSearch();
    }
  };

  handleShareCheckIn = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleShareIconSearch();
    }
  };

  handleClearMethod = () => {
    let { formFields } = this.state;
    formFields["custId"] = "";
    formFields["cust_refer"] = "";
    formFields["outstanding_amt"] = "";
    this.props.updateForm("basicApptDetail", formFields);
    this.setState({
      cartList: [],
      cartData: {},
      commonDeposit: "",
    });
  };

  // handle search
  handleSearch = async (text) => {
    let { formFields } = this.state;
    formFields.custName = text ?? "";
    await this.setState({ formFields });
    this.handleClearMethod();

    // let debounceSearch = debounce(this.search, 100);
    // debounceSearch(event.target.value);
  };

  handleSearchCustomer = (text) => {
    let { shareCustomer } = this.state;
    shareCustomer = text ?? "";
    this.setState({ shareCustomer });
  };

  //handleToRemoveDetails

  handleRemoveCustomerData = (data) => {};

  handleIconSearch = async () => {
    // this.handleClick();
    let { formFields } = this.state;
    // this.setState((prevState) => ({
    //   visible: !prevState.visible,
    // }));
    await this.setState({ visible: true });
    let data = formFields["custName"] ?? "";
    await this.search(data);
  };

  handleShareIconSearch = async () => {
    // this.handleClick();
    let { shareCustomer } = this.state;
    // this.setState((prevState) => ({
    //   visible: !prevState.visible,
    // }));
    await this.setState({ shareVisible: true });
    let data = shareCustomer ?? "";
    await this.search(data);
  };

  // handleSearch = async (event) => {
  //   //event.persist();
  //   let { formFields, visible } = this.state;
  //   formFields.custName = event.target.value;
  //   await this.setState({ formFields, visible: true });
  //   if (!this.debouncedFn) {
  //     this.debouncedFn = _.debounce(async () => {
  //       this.search();
  //     }, 500);
  //   }
  //   this.debouncedFn();
  // };

  search = (searchString) => {
    let { formFields } = this.state;
    // if (
    //   searchString == "" ||
    //   (searchString && String(searchString).length >= 3)
    // ) {
    this.props
      .getCommonApi(`custappt/?search=${searchString}`)
      .then(async (key) => {
        let { status, data } = key;

        if (status === 200) {
          // for (let value of data) {
          //     customerList.push({ value: value.id, label: value.emp_name })
          // }

          await this.setState({ customerOption: data });

          //this.setState({ cartId: "" }); //Yoonus
        }
      });
    //}
  };

  handleSelectCustomer = async (data) => {
    let { formFields } = this.state;
    formFields["custId"] = data.id;
    formFields["custName"] = data.cust_name;
    formFields["cust_refer"] = data.cust_refer;
    formFields["outstanding_amt"] = data.outstanding_amt; //Yoonus customer outstanding_amt
    formFields["IsBirthdayMonth"] = data.IsBirthdayMonth;
    formFields["cust_dob"] = data.cust_dob;

    await this.setState({
      formFields,
      // isOpenCustomer: false,
      search: "",
      customerOption: [],
    });
    await this.props.updateForm("basicApptDetail", formFields);
    console.log(this.props.basicApptDetail, "basicApptDtl");
    this.handleClick();
    this.getCart();

    // if autoto true only parendata update method called
    if (data?.cust_name && this.props.tokenDetails.ipadkey) {
      // debugger
      this.child.parentDataUpdate(data.cust_name);
    }
    if (data.IsBirthdayMonth) {
      this.setState({ showBirthdayPopup: true });
    }
  };

 handleSelectShareCustomer = async (data) => {
    const newCustomer = {
      name: data?.cust_name,
      phone: data?.cust_phone2,
      id: data?.id,
    };

    this.setState((prevState) => ({
      shareCustomer: data?.cust_name,
      storeShareCustomer: newCustomer,
      shareVisible: false,
    }));
  };

  handleSharePackage = () => {
    let { sharedCustomerList, cartList, storeShareCustomer } = this.state;
    const isAlreadyShared = sharedCustomerList.some(
      (customer) => customer.id === storeShareCustomer?.id
    );
    if (isAlreadyShared) {
      Toast({
        type: "error",
        message: "Customer already added to shared list.",
      });
      return;
    }

    const isInCartList = cartList?.some(
      (item) => item?.cust_noid === storeShareCustomer?.id
    );
    if (isInCartList) {
      Toast({
        type: "error",
        message: "Customer already found in cart list.",
      });

      return;
    }

    const newCustomer = {
      name: storeShareCustomer?.name,
      phone: storeShareCustomer?.phone,
      id: storeShareCustomer?.id,
    };

    this.setState((prevState) => ({
      sharedCustomerList: [...prevState.sharedCustomerList, newCustomer],
    }));
  };

  handleCartCreated = (data) => {
    let getData = data;

    let { cartid } = getData.data[0];
    console.log(cartid, "CartId");
    if (cartid) {
      this.handleGetData(data);
    } else {
      this.getCart();
    }
  };

  handleGetData = (getData) => {
    console.log("getData" + JSON.stringify(getData));
    let { cartId, cartData, headerDetails, formFields } = this.state;
    let { cartid } = getData.data[0];

    this.props
      .getCommonApi(
        `itemcart/?cart_date=${dateFormat(
          new Date(),
          "yyyy-mm-dd"
        )}&cust_noid=${formFields.custId}&cart_id=${cartid}`
      )
      .then(async (res) => {
        cartData = [];
        let { status, data } = res;
        console.log(res, "returndatacartitemlist");
        if (status === 200) {
          let cartList = Object.assign({}, this.state.cartList);
          if (data.length > 0) {
            data.forEach((element) => {
              let itemData = element;
              itemData["selected"] = false;
              cartData.push({
                itemData,
              });
            });
          }
          cartList = data;
          headerDetails[0]["selectAllCheck"] = false;
          this.setState({
            cartList,
            cartData: res,
            cartId: cartid,
            exchangeBalanceAmount: res.balance.slice(1),
            exchangeType: res.exchange,
            selectAll: false,
            headerDetails,
            commonDeposit: res.deposit_amt,
            treatmentCheck: false,
            salesCheck: false,
          });
        } else if (status === 204) {
          let cartList = Object.assign({}, this.state.cartList);
          cartList = [];
          cartData = {};
          let commonDeposit = "";
          this.setState({ cartData, cartList, commonDeposit });
        }
      });
  };

  // handleCheckout = () => {
  //   let { isOpenPayment, cartData, cartList, cartId, exchangeType } =
  //     this.state;
  //   let { basicApptDetail } = this.props;
  //   if (exchangeType && cartData.balance == 0) {
  //     if (cartList && cartList.length > 1) {
  //       let body = {
  //         cust_id: basicApptDetail.custId,
  //         cart_id: cartId,
  //       };
  //       this.handleExchangePayment(body);
  //     } else {
  //       Toast({
  //         type: "error",
  //         message: "Please Add Product for Exchange!",
  //       });
  //     }
  //   } else if (exchangeType && cartData.balance < 0) {
  //     if (cartList && cartList.length > 1) {
  //       this.handleExchangePay();
  //     } else {
  //       Toast({
  //         type: "error",
  //         message: "Please Add Product for Exchange!",
  //       });
  //     }
  //   } else {
  //     isOpenPayment = true;
  //     this.setState({ isOpenPayment });
  //   }
  // };
  handleCheckout = () => {
    let { cartList, cartId, formFields, appointmentId } = this.state;
    let { tokenDetails } = this.props;
    console.log(cartList, "CartList");
    if (tokenDetails.studioAbooking) {
      let { formFields } = this.state;
      let date = new Date();
      date.setHours(0, 0, 0, 0);
      this.props.getCommonApi(`studioappt/?cartid=${cartId}`).then((res) => {
        const getAppt = res?.[0];
        console.log(res, "response");
        if (getAppt) {
          this.setState({ appointmentId: getAppt.appt_id });
        } else {
          this.setState({ appointmentId: null });
        }
        this.props
          .getCommonApi(
            `weddingpackage/?cust_noid=${formFields.custId}&cart_id=${cartId}`
          )
          .then((res) => {
            let weddingPackage = res.wedding_package;
            if (weddingPackage) {
              this.setState({ isOpenModal: true });
            } else {
              this.handleCart();
            }
          });
      });
    } else {
      this.handleCart();
    }
  };

  handleCart = () => {
    let {
      isOpenPayment,
      cartData,
      cartList,
      cartId,
      exchangeType,
      formFields,
    } = this.state;
    let { basicApptDetail, tokenDetails } = this.props;
    if (cartList.length > 0 && basicApptDetail.custId) {
      if (exchangeType && cartData.balance == 0) {
        // if (cartList && cartList.length > 1) {
        let body = {
          cust_id: basicApptDetail.custId,
          cart_id: cartId,
        };
        this.handleExchangePayment(body);
        // } else {
        //   Toast({
        //     type: "error",
        //     message: "Please Add Product for Exchange!",
        //   });
        // }
      } else if (exchangeType && cartData.balance < 0) {
        // if (cartList && cartList.length > 1) {
        this.handleExchangePay();
        // } else {
        //   Toast({
        //     type: "error",
        //     message: "Please Add Product for Exchange!",
        //   });
        // }
      } else {
        isOpenPayment = true;
        this.setState({ isOpenPayment });
      }
    }
  };

  handleOpenPayment = () => {
    let { isOpenPayment } = this.state;
    isOpenPayment = true;
    this.setState({ isOpenPayment });
  };
  handleExchangePayment = (body) => {
    this.props.commonCreateApi(`exchangeproductconfirm/`, body).then((key) => {
      let { status, data } = key;
      if (status == 201) {
        this.getCart();
        history.push(`/admin/billing/print/bill/${data.sa_transacno}`);
      }
    });
  };

  handleDeleteCart = async (data) => {
    this.props.commonDeleteApi(`itemcart/${data.id}/`).then((res) => {
      let { status } = res;
      if (status == 200) {
        this.getCart();
      }
    });
  };

  handleEditCart = async (data) => {
    let { isOpenEditcart, editCart } = this.state;
    isOpenEditcart = true;
    editCart = data;
    this.setState({
      isOpenEditcart,
      editCart,
    });
  };

  handleTreatmentDone = async (item) => {
    if (item.is_tstaff && Number(item.quantity) == 1) {
      let { isOpenTreatmentDone, editCart } = this.state;
      editCart = item;
      await this.setState({ editCart });
      this.setState({ isOpenTreatmentDone: true });
    }
  };

  handleReduceQuantity = (data) => {
    let body = { quantity: 1 };
    this.props
      .commonPatchApi(`itemcart/${data.id}/qtyupdate/?check=0`, body)
      .then(() => {
        this.getCart();
      });
  };

  handleAddQuantity = (data) => {
    let body = { quantity: 1 };
    this.props
      .commonPatchApi(`itemcart/${data.id}/qtyupdate/?check=1`, body)
      .then(() => {
        this.getCart();
      });
  };

  // topup flow
  handleTopup = () => {
    let { isOpenTopup } = this.state;
    isOpenTopup = true;
    this.setState({
      isOpenTopup,
    });
  };
  handleCombinedTopup = () => {
    let isOpenCombinedTopup = true;
    this.setState({
      isOpenCombinedTopup,
    });
  };

  handleExchangeClick = () => {
    let { cartList, cartId } = this.state;
    const cart_id = cartId || this.state.cartList[0].cart_id;
    let { basicApptDetail } = this.props;
    if (cartList && cartList.length > 0 && basicApptDetail.custId) {
      let body = {
        cust_id: basicApptDetail.custId,
        cart_id: cart_id,
      };
      this.props.commonCreateApi(`exchangeproduct/`, body).then((key) => {
        let { status } = key;
        if (status == 200) {
          this.getCart();
        }
      });
    }
  };

  // handleExchangePay
  handleExchangePay = () => {
    let { isOpenExchangePayment } = this.state;
    isOpenExchangePayment = true;
    this.setState({ isOpenExchangePayment });
  };
  exchangeRemarkChange = async (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  handleExchangeLessthanZero = async (data) => {
    let { cartId, exchangeRemark } = this.state;
    let { basicApptDetail } = this.props;
    let body = {
      cust_id: basicApptDetail.custId,
      cart_id: cartId,
      remarks: exchangeRemark,
      return_type: data,
    };
    this.handleExchangePayment(body);
  };

  handleItemHeaderDblClick = (data) => {
    let { isOpenProductDetail } = this.state;
    isOpenProductDetail = data;
    this.setState({
      isOpenProductDetail,
    });
  };
  handleItemCourseClick = (data) => {
    if (data.is_course) {
      let { isOpenCourseDetail, editCart } = this.state;
      isOpenCourseDetail = true;
      editCart = data;
      this.setState({
        isOpenCourseDetail,
        editCart,
      });
    }
    if (data.is_prepaid) {
      let { isOpenPrepaidDetail, editCart } = this.state;
      isOpenPrepaidDetail = true;
      editCart = data;
      this.setState({
        isOpenPrepaidDetail,
        editCart,
      });
    }
  };

  handleCardPrepaidClick = (data) => {
    let { isOpenPrepaidDetail, editCart } = this.state;
    isOpenPrepaidDetail = true;
    editCart = data;
    this.setState({
      isOpenPrepaidDetail,
      editCart,
    });
  };
  handleCardItemCourseClick = (data) => {
    let { isOpenCourseDetail, editCart } = this.state;
    isOpenCourseDetail = true;
    editCart = data;
    this.setState({
      isOpenCourseDetail,
      editCart,
    });
  };
  handleItemStatusHeaderDblClick = (data) => {
    let { isOpenItemStatusDetail } = this.state;
    isOpenItemStatusDetail = data;
    this.setState({
      isOpenItemStatusDetail,
    });
  };

  handleDiscountDetailClick = (data) => {
    if (data.is_disc) {
      if (data.treatment_no == null || Number(data.treatment_no) <= 0) {
        let { isOpenDiscountDetail, editCart } = this.state;
        isOpenDiscountDetail = true;
        editCart = data;
        this.setState({
          isOpenDiscountDetail,
          editCart,
        });
      }
    }
  };
  handleStaffSelectionHeaderClick = (data) => {
    let { isOpenStaffSelectionDetail } = this.state;
    isOpenStaffSelectionDetail = data;
    this.setState({
      isOpenStaffSelectionDetail,
    });
  };
  handleOpenPackage = async (data) => {
    let { isOpenPackage, editCart } = this.state;
    isOpenPackage = true;
    editCart = data;
    console.log(data, "Data");
    this.setState({
      isOpenPackage,
      editCart,
    });
  };
  handleClearAllCart = async () => {
    let { cartList, cartData } = this.state;
    if (cartList.length > 0) {
      const cartId = this.state.cartList[0].cart_id;

      this.props
        .commonCreateApi(`cartitemdelete/?cart_id=${cartId}`)
        .then((res) => {
          this.setState({
            cartList: [],
            cartData: {},
            commonDeposit: "",
            depositPriceGst: false,            
          });
          this.getCart();
          this.handleClearAllConfirmation();
        });
    }
  };
  handleDialogCoursepopup = () => {
    this.getCourseListCheckForReset();
    this.handleDialog();
  };

  getCourseListCheckForReset = () => {
    let { editCart } = this.state;
    this.props
      .getCommonApi(`cartservicecourse/${editCart.id}/`)
      .then(async (key) => {
        let { status, data } = key;
        console.log(data, "cartcoursepopupforreset");
        if (status == "200") {
          if (data) {
            if (
              // !data.is_service &&
              Number(data.treatment_no) == 0 ||
              data.treatment_no == null
            ) {
              let body = {
                cart_id: editCart.id,
              };
              this.props
                .commonCreateApi(`cartservicecourse/reset/`, body)
                .then(async (key) => {
                  let { status, data } = key;
                  console.log(key, "resetresponse");
                });
            }
          }
        }
      });
  };

  // handleChangeDefaultstaff = e => {
  //   this.setState({
  //     [e.target.name]: e.target.value,
  //   });
  //   let { cartList } = this.state;
  //   let cartListCheckbox = cartList.find(acc => acc.selected === true);
  //   if (cartListCheckbox) {
  //     let { cartList } = this.state;
  //     let cartIds = "";
  //     for (let item of cartList) {
  //       if (item.selected) {
  //         if (cartIds !== "") {
  //           cartIds += "," + item.id;
  //         } else {
  //           cartIds += item.id;
  //         }
  //       }
  //     }

  //     let body = {
  //       cart_id: cartIds,
  //       staff_id: e.target.value,
  //       is_sales: true,
  //       is_work: false,
  //     };
  //     try {
  //       this.props.commonCreateApi(`addremovestaff/`, body).then(key => {
  //         let { status, data } = key;
  //         if (status == 200) {
  //           this.getCart();
  //         }
  //       });
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   }
  // };

  // handleCommonAddNewStaff = async () => {
  //   let { cartList, treatmentCheck, salesCheck } = this.state;
  //   if (salesCheck == true || treatmentCheck == true) {
  //     let cartListCheckbox = cartList.find(acc => acc.selected === true);
  //     if (cartListCheckbox) {
  //       await this.setState({
  //         staffList: [],
  //         meta: {},
  //         page: 1,
  //       });
  //       this.getStafflist();
  //       this.setState({
  //         staffCommonListPopup: true,
  //       });
  //     } else {
  //       Toast({
  //         type: "error",
  //         message: "Please Select Item for update!",
  //       });
  //     }
  //   } else {
  //     Toast({
  //       type: "error",
  //       message: "Please Select Sales or Work!",
  //     });
  //   }
  // };

  handleCommonCreateEmployeePopup = () => {
    this.setState((prevState) => ({
      staffCommonListPopup: !prevState.staffCommonListPopup,
    }));
  };

  getStafflist = (data) => {
    let { page, limit, selectedAddStaffType } = this.state;
    this.props
      .getCommonApi(`empcartlist/?sales_staff=1&page=${page}&limit=${limit}`)
      .then(async (key) => {
        let { status, data } = key;
        console.log(key, "sdfgsdfgsdfgdfg sdfgsdfgsdfg");
        let { staffList } = this.state;
        let { meta } = this.state;
        staffList = [];
        meta = {};
        staffList = data;
        meta = data.meta.pagination;
        console.log(meta, "metalist");
        this.setState({
          staffList,
          meta,
        });
      });
  };

  handleNext = async () => {
    let { page } = this.state;
    page = page + 1;
    await this.setState({
      page,
    });
    if (page > 0) {
      this.getStafflist();
    }
  };

  handleBack = async () => {
    let { page } = this.state;
    page = page - 1;
    await this.setState({
      page,
    });
    if (page > 0) {
      this.getStafflist();
    }
  };

  // handleCommonSelectedStaff = async selectedItem => {
  //   let { cartList, treatmentCheck, salesCheck } = this.state;
  //   let cartIds = "";
  //   for (let item of cartList) {
  //     if (item.selected) {
  //       if (cartIds !== "") {
  //         cartIds += "," + item.id;
  //       } else {
  //         cartIds += item.id;
  //       }
  //     }
  //   }

  //   let body = {
  //     cart_id: cartIds,
  //     staff_id: selectedItem.id,
  //     is_sales: salesCheck,
  //     is_work: treatmentCheck,
  //   };

  //   this.handleCommonAddNewStaffAPI(body);
  // };

  // handleCommonDeleteSelectedStaff = async selectedItem => {
  //   let { cartList, treatmentCheck, salesCheck } = this.state;
  //   let cartIds = "";
  //   for (let item of cartList) {
  //     if (item.selected) {
  //       if (cartIds !== "") {
  //         cartIds += "," + item.id;
  //       } else {
  //         cartIds += item.id;
  //       }
  //     }
  //   }

  //   let body = {
  //     cart_id: cartIds,
  //     staff_id: selectedItem.id,
  //     is_sales: salesCheck,
  //     is_work: treatmentCheck,
  //   };

  //   this.handleCommonDeleteNewStaffAPI(body);
  // };

  handleSelectAllCheckbox = async ({ target: { value, name } }) => {
    let { cartList, headerDetails } = this.state;
    headerDetails[0]["selectAllCheck"] = value;
    await this.setState({ selectAll: value, headerDetails });

    for (let item of cartList) {
      item["selected"] = value;
      await this.setState({ ...this.state.cartList, item }, () => {
        // if (value) {
        //   this.handleCheckBoxValidation();
        // } else {
        //   this.handleToAllUnselect();
        // }
      });
    }
    await this.setState({ cartList });
  };
  handleCheckbox = async ({ target: { value, name } }, item) => {
    let { cartList } = this.state;
    let cartListCheckbox = cartList.find((acc) => acc.id === item.id);
    if (cartListCheckbox) {
      cartListCheckbox["selected"] = value;
      await this.setState({ ...this.state.cartList, cartListCheckbox }, () => {
        if (value) {
          this.handleCheckBoxValidation();
        } else {
          this.handleToUnselectCheckBox();
        }
      });
    }
  };

  handleSelectAllTax = async ({ target: { value, name } }) => {
    let { cartList, headerDetails } = this.state;
    headerDetails[1]["selectAllCheck"] = value;
    await this.setState({ selectAllTax: value, headerDetails });

    for (let item of cartList) {
      item["priceincludegst"] = value;
      await this.setState({ ...this.state.cartList, item }, () => {
        let body = {
          quantity: item?.quantity,
          price: item?.price,
          sales_staff: [],
          itemstatus: null,
          remark: null,
          focreason: null,
          holdreason: null,
          holditemqty: null,
          ratio: null,
          priceincludegst: value,
        };
        try {
          this.props
            .commonUpdateApi(`itemcart/${item?.id}/`, body)
            .then(async () => {
              this.getCart();
            });
        } catch (e) {
          console.log(e);
        }
      });
    }
    await this.setState({ cartList });
  };

  handleTaxCheckbox = async ({ target: { value, name } }, item) => {
    let { cartList } = this.state;
    let cartListCheckbox = cartList.find((acc) => acc.id === item.id);
    if (cartListCheckbox) {
      cartListCheckbox["priceincludegst"] = value;
      await this.setState({ ...this.state.cartList, cartListCheckbox }, () => {
        let body = {
          quantity: item?.quantity,
          price: item?.price,
          sales_staff: [],
          itemstatus: null,
          remark: null,
          focreason: null,
          holdreason: null,
          holditemqty: null,
          ratio: null,
          priceincludegst: value,
        };
        try {
          this.props
            .commonUpdateApi(`itemcart/${item?.id}/`, body)
            .then(async () => {
              this.getCart();
            });
        } catch (e) {
          console.log(e);
        }
      });
    }
  };

  handleDepositGst = async ({ target: { value, name } }) => {
    let { depositPriceGst, commonDeposit, taxAmount } = this.state;
    depositPriceGst = value;
    if (depositPriceGst) {
      taxAmount = (Number(commonDeposit) / 109) * 9;
      commonDeposit = (Number(commonDeposit) - taxAmount).toFixed(2);
      this.handleDepositChange(commonDeposit);
    } else {
      commonDeposit = (
        Number(commonDeposit) +
        Number(commonDeposit) * 0.09
      ).toFixed(2);

      taxAmount = 0;
      this.handleDepositChange(commonDeposit);
    }
    this.setState({ depositPriceGst, taxAmount });
  };

  handlesingleCheckbox = async (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      if (e.target.value) {
        this.handleCheckBoxValidation();
      } else {
        this.handleToUnselectCheckBox(e.target.name);
      }
    });
  };

  handleToAllUnselect = () => {
    let { salesCheck, treatmentCheck, cartList, headerDetails } = this.state;
    let unSelectStatus = cartList.every((item) => item.selected === false);

    if (unSelectStatus) {
      headerDetails[0]["selectAllCheck"] = false;
      this.setState({ selectAll: false, headerDetails });
      if (salesCheck || treatmentCheck) {
        this.setState({ switchChecked: false });
      }
    }
  };

  handleToUnselectCheckBox = (val) => {
    let { salesCheck, treatmentCheck, cartList, headerDetails } = this.state;
    let cartlistValidation = cartList.some((item) => item.selected === true);
    if (val === "salesCheck") {
      if (!treatmentCheck && !cartlistValidation) {
        this.setState({ switchChecked: true });
      }
    } else if (val === "treatmentCheck") {
      if (!salesCheck && !cartlistValidation) {
        this.setState({ switchChecked: true });
      }
    } else if (!treatmentCheck && !cartlistValidation) {
      this.setState({ switchChecked: true });
    } else if (!salesCheck && !cartlistValidation) {
      this.setState({ switchChecked: true });
    }
  };

  //handleCheckBoxValidation
  handleCheckBoxValidation = () => {
    let { salesCheck, treatmentCheck, cartList } = this.state;
    let cartlistValidation = cartList.some((item) => item.selected === true);
    if (salesCheck || treatmentCheck || cartlistValidation) {
      this.setState({ switchChecked: false });
    }
  };

  //handleChangeSwitch
  handleChangeSwitch = (checked) => {
    // let { salesCheck, treatmentCheck, cartList } = this.state;
    // let cartlistValidation = cartList.some((item) => item.selected === true);
    // if (salesCheck || treatmentCheck || cartlistValidation) {
    //   this.setState({ switchChecked: true });
    // }
    this.setState({ switchChecked: checked });
    this.setState({ salesCheck: false, treatmentCheck: false });
    let payload = {
      target: {
        value: false,
      },
    };
    this.handleSelectAllCheckbox(payload);
  };

  // handleCommonDeleteNewStaffAPI = body => {
  //   try {
  //     this.props.commonCreateApi(`addremovestaff/remove/`, body).then(key => {
  //       let { status, data } = key;
  //       if (status == 200) {
  //         this.getCart();
  //         this.handleCommonDeleteEmployeePopup();
  //       }
  //     });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // handleCommonAddNewStaffAPI = body => {
  //   try {
  //     this.props.commonCreateApi(`addremovestaff/`, body).then(key => {
  //       let { status, data } = key;
  //       if (status == 200) {
  //         this.getCart();
  //         this.handleCommonCreateEmployeePopup();
  //       }
  //     });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // handleCommonDeleteEmployeePopup = () => {
  //   this.setState(prevState => ({
  //     staffDeleteCommonListPopup: !prevState.staffDeleteCommonListPopup,
  //   }));
  // };

  // handleCommonDeleteStaffClick = async () => {
  //   let { cartList, treatmentCheck, salesCheck } = this.state;
  //   if (salesCheck == true || treatmentCheck == true) {
  //     let cartListCheckbox = cartList.find(acc => acc.selected === true);
  //     if (cartListCheckbox) {
  //       await this.setState({
  //         availableStaffList: [],
  //         availstaffmeta: {},
  //         availstaffpage: 1,
  //       });
  //       this.getStafflistforMatch();
  //       this.setState({
  //         staffDeleteCommonListPopup: true,
  //       });
  //     } else {
  //       Toast({
  //         type: "error",
  //         message: "Please Select Item for update!",
  //       });
  //     }
  //   } else {
  //     Toast({
  //       type: "error",
  //       message: "Please Select Sales or Work!",
  //     });
  //   }
  // };

  getStafflistforMatch = (data) => {
    let { availstaffpage, availstaffmeta, availableStaffList, limit, cartId } =
      this.state;
    let { basicApptDetail } = this.props;
    this.props
      .getCommonApi(
        `itemcart/salesstafflist/?cust_noid=${basicApptDetail.custId}&cart_id=${cartId}&page=${availstaffpage}&limit=${limit}`
      )
      .then(async (key) => {
        let { status, data } = key;
        console.log(key, "deletestafflist");
        availableStaffList = [];
        availstaffmeta = {};
        if (data) {
          availableStaffList = data;
          availstaffmeta = data.meta.pagination;
        }
        console.log(availstaffmeta, "metalist");
        this.setState({
          availableStaffList,
          availstaffmeta,
        });
      });
  };

  handleavailStaffNext = async () => {
    let { availstaffpage } = this.state;
    availstaffpage = availstaffpage + 1;
    await this.setState({
      availstaffpage,
    });
    if (availstaffpage > 0) {
      this.getStafflistforMatch();
    }
  };

  handleavailStaffBack = async () => {
    let { availstaffpage } = this.state;
    availstaffpage = availstaffpage - 1;
    await this.setState({
      availstaffpage,
    });
    if (availstaffpage > 0) {
      this.getStafflistforMatch();
    }
  };

  handleQtyChange = (event, item, index) => {
    if (Number(event.target.value) > 200) {
      //Yoonus add to control for mirage quantity
      Toast({
        type: "error",
        message: "Quantity not allowed above 200!",
      });
    } else if (Number(event.target.value) > 0) {
      //event.persist();
      let { cartList } = this.state;
      cartList[index]["quantity"] = event.target.value;
      let changedItem = item.id;
      this.setState({ cartList, changedItem });
      if (!this.debouncedQtyFn) {
        this.debouncedQtyFn = _.debounce(() => {
          this.handleQtyApiUpdate();
        }, 1000);
      }
      this.debouncedQtyFn();
    } else {
      Toast({
        type: "error",
        message: "Please enter valid quantity!",
      });
    }
  };

  handleQtyApiUpdate = () => {
    let { cartList, changedItem } = this.state;
    if (changedItem) {
      let ChangedList = cartList.filter((item) => item.id == changedItem);
      let qty = ChangedList[0]["quantity"];
      let id = ChangedList[0]["id"];
      let body = { quantity: qty };

      this.props
        .commonPatchApi(`itemcart/${id}/qtyupdate/`, body)
        .then(async () => {
          await this.setState({
            changedItem: "",
          });
          this.getCart();
        });
    }
  };

  handleUnitPriceChange = (event, item, index) => {
    //event.persist();
    // let selectedItemPrice = Number(item.price).toFixed(2);
    // let selectedItemData = item;
    // let selectedItemIndex = index;

    // if (Number(event.target.value) > 0) {
    //   let { cartList, changedItem, selectedItemPrice } = this.state;
    //   cartList[index]["price"] = Number(event.target.value);
    //   changedItem = item.id;
    //   this.setState({
    //     cartList,
    //     changedItem,
    //   });
    //   if (!this.debouncedPriceFn) {
    //     this.debouncedPriceFn = _.debounce(async () => {
    //       this.handleUnitPriceApiUpdate();
    //     }, 3000);
    //   }
    //   this.debouncedPriceFn();
    // } else {
    //   Toast({
    //     type: "error",
    //     message: "Please enter valid amount!",
    //   });
    // }
    let { cartList, changedItem, selectedItemPrice } = this.state;
    if (event.target.value === "" || Number(event.target.value) === 0) {
      cartList[index]["price"] = event.target.value;
      changedItem = item.id;
      this.setState({
        cartList,
        changedItem,
      });
      return;
    } else {
      cartList[index]["price"] = Number(event.target.value);
      changedItem = item.id;
      this.setState({
        cartList,
        changedItem,
      });
      if (!this.debouncedPriceFn) {
        this.debouncedPriceFn = _.debounce(async () => {
          this.handleUnitPriceApiUpdate();
        }, 3000);
      }
      this.debouncedPriceFn();
    }
  };

  handleUnitPriceApiUpdate = async () => {
    let { cartList, changedItem } = this.state;
    if (changedItem) {
      let ChangedList = cartList.filter((item) => item.id == changedItem);
      if (
        Number(ChangedList[0].item_price_ceiling) > 0 &&
        Number(ChangedList[0].price) > Number(ChangedList[0].item_price_ceiling)
      ) {
        Toast({
          type: "error",
          message: `Please enter value between ${ChangedList[0].item_price_floor} (min) and ${ChangedList[0].item_price_ceiling} (max)`,
        });
        ChangedList[0]["price"] = ChangedList[0]["discount_price"];
        this.setState({
          ChangedList,
        });
        return false;
      } else if (
        Number(ChangedList[0].item_price_floor) > 0 &&
        Number(ChangedList[0].price) < Number(ChangedList[0].item_price_floor)
      ) {
        Toast({
          type: "error",
          message: `Please enter value between ${ChangedList[0].item_price_floor} (min) and ${ChangedList[0].item_price_ceiling} (max)`,
        });
        ChangedList[0]["price"] = ChangedList[0]["discount_price"];
        this.setState({
          ChangedList,
        });

        return false;
      } else {
        let qty = ChangedList[0]["quantity"];
        let id = ChangedList[0]["id"];
        let pricevalue = ChangedList[0]["price"];

        let body = {
          quantity: Number(qty),
          price: Number(pricevalue).toFixed(2),
          sales_staff: [],
          itemstatus: null,
          remark: null,
          focreason: null,
          holdreason: null,
          holditemqty: null,
          ratio: null,
        };
        try {
          this.props.commonUpdateApi(`itemcart/${id}/`, body).then(async () => {
            await this.setState({
              changedItem: "",
            });
          });
        } catch (e) {
          console.log(e);
        }
        this.getCart();
      }
    }
  };

  handleRadioCheckbox = async (type) => {
    let { is_selectDeposit } = this.state;
    if (type !== is_selectDeposit) {
      await this.setState({
        is_selectDeposit: type,
      });
      this.handleCommonDepositApiUpdate();
    }
  };

  handleDepositChange = async (val) => {
    let { cartList } = this.state;
    if (Number(val) >= 0 && cartList.length > 0) {
      //event.persist();
      let { commonDeposit } = this.state;
      commonDeposit = Number(val);
      await this.setState({ commonDeposit });
      if (!this.debouncedDepositAmountFn) {
        this.debouncedDepositAmountFn = _.debounce(() => {
          this.handleCommonDepositApiUpdate();
        }, 1000);
      }
      this.debouncedDepositAmountFn();
    }
  };

  handleCommonDepositApiUpdate = () => {
    let { cartList, is_selectDeposit, commonDeposit, cartId } = this.state;
    let { basicApptDetail } = this.props;
    if (is_selectDeposit) {
      let body = {
        cust_noid: basicApptDetail.custId,
        cart_id: cartId || cartList[0].cart_id,
        is_select: is_selectDeposit,
        enter_deposit: Number(commonDeposit),
      };
      try {
        this.props
          .commonCreateApi(`itemcart/SetAutoDeposit/`, body)
          .then(async () => {
            this.getCart();
          });
      } catch (e) {
        console.log(e);
      }
    } else {
      Toast({
        type: "error",
        message: "Please select calculation type!",
      });
    }
  };

  handleMultiSelectDefaultStaff = (data = []) => {
    let { defaultStaff } = this.state;
    defaultStaff = data;
    this.setState({ defaultStaff });
  };
  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  handleCommonApplyStaffPrompt = async () => {
    let { cartList, treatmentCheck, salesCheck, defaultStaff } = this.state;
    console.log(cartList, "cartList");
    console.log(treatmentCheck, "work");
    console.log(salesCheck, "sales");
    if (
      cartList.some((item) => item.duration_product === 1 && item.selected) &&
      treatmentCheck
    ) {
      Toast({
        type: "error",
        message:
          "Please click on Service Name to add Treatment Staff for Duration based Services",
      });
      return;
    }

    if (defaultStaff.length > 0) {
      if (salesCheck == true || treatmentCheck == true) {
        let cartListCheckbox = cartList.find((acc) => acc.selected === true);
        if (cartListCheckbox) {
          let { cartList } = this.state;
          let cartIds = "";
          for (let item of cartList) {
            if (item.selected) {
              if (cartIds !== "") {
                cartIds += "," + item.id;
              } else {
                cartIds += item.id;
              }
            }
          }
          try {
            this.props
              .getCommonApi(`addremovestaff/?cart_ids=${cartIds}`)
              .then(async (key) => {
                let { status, isvalidatepw } = key;
                if (status == 200) {
                  console.log(
                    "addremovestaff",
                    JSON.stringify(key?.isvalidatepw)
                  );
                  if (key?.isvalidatepw) {
                    await this.setState({
                      isStaffLoginConfirmation: true,
                    });
                  } else {
                    this.handleCommonApplyStaff();
                  }
                }
              });
          } catch (e) {
            console.log(e);
          }
        } else {
          Toast({
            type: "error",
            message: "Please Select Item for update!",
          });
        }
      } else {
        Toast({
          type: "error",
          message: "Please Select Sales or Work!",
        });
      }
    } else {
      Toast({
        type: "error",
        message: "Please Select Staff!",
      });
    }
  };

  handleCommonApplyStaff = async (user, pass) => {
    let { cartList, treatmentCheck, salesCheck, defaultStaff } = this.state;
    if (defaultStaff.length > 0) {
      if (salesCheck == true || treatmentCheck == true) {
        let cartListCheckbox = cartList.find((acc) => acc.selected === true);
        if (cartListCheckbox) {
          let { cartList } = this.state;
          let cartIds = "";
          for (let item of cartList) {
            if (item.selected) {
              if (cartIds !== "") {
                cartIds += "," + item.id;
              } else {
                cartIds += item.id;
              }
            }
          }

          let body = {
            cart_id: cartIds,
            staff_id: defaultStaff
              .map((e) => e.value)
              .reduce((a, e) => (a === "" ? e : a + "," + e), ""),
            is_sales: salesCheck,
            is_work: treatmentCheck,
          };
          if (user) body.username = user ?? "";
          if (pass) body.password = pass ?? "";
          try {
            this.props.commonCreateApi(`addremovestaff/`, body).then((key) => {
              let { status, data } = key;
              if (status == 200) {
                while (defaultStaff.length > 0) {
                  document
                    .querySelector(".select__multi-value__remove")
                    .click();
                  defaultStaff.pop();
                }
                this.setState({
                  defaultStaff: [],
                  isStaffLoginConfirmation: false,
                });
                this.getCart();
              }
            });
          } catch (e) {
            console.log(e);
          }
        } else {
          Toast({
            type: "error",
            message: "Please Select Item for update!",
          });
        }
      } else {
        Toast({
          type: "error",
          message: "Please Select Sales or Work!",
        });
      }
    } else {
      Toast({
        type: "error",
        message: "Please Select Staff!",
      });
    }
  };

  handleClearAllConfirmation = () => {
    this.setState((prevState) => ({
      isHandleConfirmationDialog: !prevState.isHandleConfirmationDialog,
    }));
  };

  handleLoginConfirmationDialog = async () => {
    let { cartList } = this.state;
    if (cartList.length > 0) {
      let { settingData } = this.state;
      if (settingData.transacdisc) {
        await this.setState((prevState) => ({
          isLoginConfirmation: !prevState.isLoginConfirmation,
        }));
      } else {
        this.handleOpenTrac();
      }
    }
  };

  handleExchangeConfirmationDialog = () => {
    this.setState({
      isExchangeConfirmation: !this.state.isExchangeConfirmation,
    });
  };

  handleStaffLoginConfirmationDialog = () => {
    this.setState({
      isStaffLoginConfirmation: false,
    });
  };
  handleBirthdayPopup = () => {
    this.setState({
      showBirthdayPopup: false,
    });
  };
 
  handleCustomerClassExpiredPopup = () => {
    this.setState({
      showCustomerClassExpiredPopup: false,
    });
  };

  handleauthentication = async (user, pass) => {
    let Body = {
      username: user,
      password: pass,
    };
    this.props
      .commonCreateApi(`itemcart/TransacDiscLogin/`, Body)
      .then(async (key) => {
        let { status, data } = key;
        if (status == 200) {
          await this.setState((prevState) => ({
            isLoginConfirmation: !prevState.isLoginConfirmation,
          }));
          this.handleOpenTrac();
        }
      });
  };

  handleExchangeAuthentication = async (user, pass) => {
    let Body = {
      username: user,
      password: pass,
      type: "Exchange",
    };
    this.props
      .commonCreateApi(`userauthorizationpopup/`, Body)
      .then(async (key) => {
        let { status, data } = key;
        if (status == 200) {
          await this.setState((prevState) => ({
            isExchangeConfirmation: !prevState.isExchangeConfirmation,
          }));
          this.handleExchangeClick();
        }
      });
  };

  handleExchangeAuth = () => {
    if (this.props.tokenDetails?.showauthforexchange) {
      this.handleExchangeConfirmationDialog();
    } else {
      this.handleExchangeClick();
    }
  };

  handleOpenTrac = async () => {
    await this.setState((prevState) => ({
      isOpenEditDisc: !prevState.isOpenEditDisc,
    }));
  };

  // handleToFoucsInput
  handleToFoucsInput = async (elem) => {
    const searchTextInput = document.getElementById(elem);
    searchTextInput.focus();
    setTimeout(() => {
      searchTextInput.blur();
    }, 100);
    // The input will lose focus after 3 seconds
  };

 handleShareIcon = (item) => {
    this.setState({
      isSharePopup: true,
      selectedPackage: item,
    });
  };

  handleShareDialog = () => {
    this.setState({
      isSharePopup: false,
    });
  };

  handleSharePackageConfirm = () => {
    let { sharedCustomerList, selectedPackage } = this.state;
    let payload = sharedCustomerList
      ?.filter((list) => !list?.customer_id)
      ?.map((item) => ({
        itemcart_id: selectedPackage?.id,
        customer_id: item?.id,
        customerName: item?.name,
        customerPhone: item?.phone,
      }));
    this.props.updateCommon("ItemCartCustomersShareds", payload).then((res) => {
      this.setState({
        isSharePopup: false,
        sharedCustomerList: [],
        shareCustomer: "",
      });
    });
  };

  handleDeleteSharePackage = (list) => {
    let { sharedCustomerList } = this.state;
    console.log(list, "list");
    if (list?.customer_id) {
      this.props
        .commonDeleteBackendApi(`ItemCartCustomersShareds/${list?.id}`)
        .then((res) => {
          const updatedList = sharedCustomerList.filter(
            (item) => item.id !== list.id
          );
          this.setState({ sharedCustomerList: updatedList });
        })
        .catch((err) => {
          console.log(err, "Error");
        });
    } else {
      const updatedList = sharedCustomerList.filter(
        (item) => item.id !== list.id
      );
      this.setState({ sharedCustomerList: updatedList });
    }
  };

  handleGetSharedPackages = () => {
    let { selectedPackage } = this.state;
    this.props
      .getBackendCommonApi(
        `ItemCartCustomersShareds/?filter=%7B%22where%22%3A%7B%22itemcart_id%22%3A%22${selectedPackage?.id}%20%22%7D%7D`
      )
      .then((res) => {
        console.log(res, "Reponse");
        let customerList = res?.map((list) => ({
          ...list,
          name: list?.customerName,
          phone: list?.customerPhone,
        }));
        this.setState({
          sharedCustomerList: customerList,
        });
      });
  };

  // // handleSetCustomerName

  // handleSetCustomerName = (val) => {
  //   let { formFields } = this.state;
  //   formFields["custName"] = val;
  //   this.setState({ formFields });
  // };

  //

  render() {
    let {
      cartList,
      customerOption,
      cartData = {},
      editCart = {},
      isOpenTreatmentDone,
      formFields,
      isOpenPayment,
      isOpenEditDisc,
      isOpenEditcart,
      headerDetails,
      showBirthdayPopup,
      showCustomerClassExpiredPopup,
      editSelectedTdUnitPrice,
      isOpenCustomer,
      cartId,
      isOpenTopup,
      search,
      exchangeBalance,
      isOpenExchangePayment,
      exchangeRemark,
      exchangeBalanceAmount,
      isOpenProductDetail,
      isOpenCourseDetail,
      isOpenPrepaidDetail,
      isOpenDiscountDetail,
      isOpenItemStatusDetail,
      isOpenStaffSelectionDetail,
      visible,
      isOpenPackage,
      defaultStaff,
      salesdefaultStaff,
      isOpenCombinedTopup,
      settingData,
      staffCommonListPopup,
      staffList,
      meta,
      selectAll,
      staffDeleteCommonListPopup,
      availableStaffList,
      availstaffmeta,
      salesCheck,
      treatmentCheck,
      commonDeposit,
      isHandleConfirmationDialog,
      isLoginConfirmation,
      isExchangeConfirmation,
      isStaffLoginConfirmation,
      switchCheckedOff,
      deviceWidthCheck,
      isCreateAppointment,
      isOpenModal,
      appointmentId,
      isSharePopup,
      shareCustomer,
      shareVisible,
      shareHeaderDetails,
      sharedCustomerList,
      selectedPackage,

    } = this.state;
    console.log(cartId, "stateCart");
    let { basicApptDetail, t, tokenDetails } = this.props;
    let { ipadkey } = tokenDetails;
    return (
      <div className="row new-cart ">
        {console.log("switchChecked", switchCheckedOff)}
        <div
          className={`col-12 col-sm-12 col-md-12  ${
            switchCheckedOff ? "col-xl-7" : "col-xl-12"
          } ${deviceWidthCheck <= 1199 ? "col-lg-12" : "col-lg-8"} cart-item`}
        >
          <div className={`item-list`}>
            <div className="row mt-3 mt-sm-0">
              <div
                className={`col-11 col-sm-10 col-md-10 col-lg-5 col-xl-4 ${
                  ipadkey ? "mt-lg-3" : "mt-lg-4"
                } mt-sm-3`}
              >
                {ipadkey ? (
                  <SearchInputKeyboard
                    onRef={(ref) => (this.child = ref)}
                    onChangeTextInput={(e) => this.handleSearch(e)}
                    handleIconSearch={() => {
                      this.handleIconSearch();
                    }}
                    handleHideModal={(val) => this.setState({ visible: val })}
                    focusValue={"searchCatalogInput"}
                    placeHolderText={"Search Customer.."}
                    parentPassIntialValue={formFields.custName}
                    keyboardModalValue
                  />
                ) : (
                  <NormalInput
                    placeholder="Search Customer...."
                    value={formFields.custName}
                    name="custName"
                    onChange={(e) => this.handleSearch(e.target.value)}
                    onKeyDown={this.handlecheckIN}
                    iconsVisible
                    onClickIcon={() => {
                      this.handleIconSearch();
                    }}
                  />
                )}

                {this.validator.message(
                  "customerName",
                  formFields.custName,
                  "required"
                )}
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-8 pt-2">
                <div className="row">
                  <div className="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2  input-group text-right  my-2 p-0 cartMenuGrpBtn">
                    <NormalButton
                      onClick={() =>
                        this.handleItemSettings(
                          this.props.tokenDetails?.walkincust
                        )
                      }
                      className="fs-14 text-center borderRadiusBtn"
                      label="W"
                      buttonClass={"share"}
                      mainbgrev={true}
                      disabled={
                        this.props.tokenDetails?.walkincust ? false : true
                      }
                    />
                    <h6 className="btnSubTitle">WC</h6>
                  </div>
                  <div className="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 input-group text-right  my-2 p-0 cartMenuGrpBtn">
                    <NormalButton
                      buttonClass={"share"}
                      mainbgrev={true}
                      className="fs-14 text-center borderRadiusBtn"
                      label=""
                      onClick={() =>
                        history.push(
                          `/admin/cart/treatment-done/${basicApptDetail.custId}`
                        )
                      }
                      disabled={!basicApptDetail.custId}
                      leftIcon={tdIcon}
                    />
                    <h6 className="btnSubTitle">TD</h6>
                  </div>
                  {settingData.topupScreenOption1or2 ? (
                    <div className="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 input-group text-right  my-2 p-0  cartMenuGrpBtn">
                      <NormalButton
                        buttonClass={
                          basicApptDetail.outstanding_amt > 0
                            ? "danger"
                            : "share "
                        }
                        styleTwo={true}
                        className="text-center borderRadiusBtn"
                        label=""
                        onClick={() => this.handleTopup()}
                        disabled={!basicApptDetail.custId}
                        leftIcon={
                          basicApptDetail.outstanding_amt > 0
                            ? payIcon
                            : topupIcon
                        }
                      />
                      <h6 className="btnSubTitle">
                        {basicApptDetail.outstanding_amt > 0 ? "Pay $" : "AR"}
                      </h6>
                    </div>
                  ) : (
                    <div className="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 input-group text-right  my-2 p-0  cartMenuGrpBtn">
                      <NormalButton
                        buttonClass={
                          basicApptDetail.outstanding_amt > 0
                            ? "danger "
                            : "share "
                        }
                        styleTwo={true}
                        className="text-center borderRadiusBtn"
                        label=""
                        onClick={() => this.handleCombinedTopup()}
                        disabled={!basicApptDetail.custId}
                        leftIcon={
                          basicApptDetail.outstanding_amt > 0
                            ? payIcon
                            : topupIcon
                        }
                      />
                      <h6 className="btnSubTitle">
                        {basicApptDetail.outstanding_amt > 0 ? "Pay $" : "AR"}
                      </h6>
                    </div>
                  )}
                  <div className="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 input-group text-right  my-2 p-0  cartMenuGrpBtn">
                    <NormalButton
                      buttonClass={"share"}
                      styleThree={true}
                      className="text-center borderRadiusBtn"
                      label=""
                      onClick={() => history.push("/admin/cart/bill-ops")}
                      disabled={!basicApptDetail.custId}
                      leftIcon={billOpsIcon}
                    />
                    <h6 className="btnSubTitle">Void</h6>
                  </div>
                  <div className="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2  input-group text-right  my-2 p-0  cartMenuGrpBtn">
                    <NormalButton
                      buttonClass={"share"}
                      styleFour={true}
                      className="text-center borderRadiusBtn"
                      label=""
                      onClick={() =>
                        history.push(
                          "/admin/customerplus/" +
                            basicApptDetail.custId +
                            "/details"
                        )
                      }
                      disabled={!basicApptDetail.custId}
                      leftIcon={profileIcon}
                    />
                    <h6 className="btnSubTitle">Profile</h6>
                  </div>
                  {cartList && cartList.length > 0 ? (
                    <div className="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 input-group text-right  my-2 p-0  cartMenuGrpBtn">
                      <NormalButton
                        buttonClass={"share"}
                        styleFive={true}
                        className="text-center borderRadiusBtn"
                        label=""
                        onClick={this.handleExchangeAuth}
                        disabled={!basicApptDetail.custId}
                        leftIcon={exchangeIcon}
                      />
                      <h6 className="btnSubTitle">Exchange</h6>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="row">
              <div
                className={
                  switchCheckedOff
                    ? `${
                        deviceWidthCheck <= 1199 ? "d-block" : "d-lg-none"
                      } col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-2 pr-0 `
                    : `d-none`
                }
              >
                <Treatment
                  handleCartCreated={this.handleCartCreated}
                  cartData={cartList}
                  handleCardItemCourseClick={(editCart) =>
                    this.handleCardItemCourseClick(editCart)
                  }
                  handleCardPrepaidClick={(editCart) =>
                    this.handleCardPrepaidClick(editCart)
                  }
                  custId={
                    formFields && formFields.custId
                      ? formFields.custId
                      : basicApptDetail.custId
                  }
                  defaultStaffId={defaultStaff}
                  cartId={cartId}
                ></Treatment>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-4">
                <div className="row row mb-2 mb-lg-0">
                  <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-4 d-none">
                    <Switch
                      onChange={(e) => this.handleChangeSwitch(e)}
                      checked={switchCheckedOff}
                      className="m-1"
                    />
                  </div>
                  <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-4 mt-2">
                    <NormalCheckbox
                      onChange={(e) => this.handlesingleCheckbox(e)}
                      name="salesCheck"
                      checked={salesCheck}
                      type="checkbox"
                      inputClass={`col-12 m-1 p-1 fw-500`}
                      label="Sales"
                    />
                  </div>
                  <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-4 mt-2">
                    <NormalCheckbox
                      onChange={(e) => this.handlesingleCheckbox(e)}
                      name="treatmentCheck"
                      checked={treatmentCheck}
                      type="checkbox"
                      inputClass={`col-12 m-1 p-1 fw-500`}
                      label="Work"
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 my-2">
                <div className="row rowGapBottom">
                  <div className="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-8 ">
                    <NormalMultiSelect
                      handleMultiSelect={this.handleMultiSelectDefaultStaff}
                      options={salesdefaultStaff}
                      value={this.state.defaultStaff}
                      name="defaultStaff"
                    />
                  </div>
                  <div className="col-12 col-sm-3 col-md-3 col-lg-2 col-xl-3 input-group">
                    <NormalButton
                      buttonClass={"share w-100"}
                      applybg={true}
                      className="col-12"
                      label="Apply"
                      onClick={this.handleCommonApplyStaffPrompt}
                      disabled={cartList && cartList.length > 0 ? false : true}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* {cartList && cartList.length > 0 ? (
                    <div className="input-group text-right col-md-3 col-12 my-2">
                      <NormalButton
                        buttonClass={"share w-100"}
                        applybg={true}
                        className="col-12"
                        label="Add Staff"
                        onClick={this.handleCommonAddNewStaff}
                      />
                    </div>
                  ) : null} 
                  {cartList && cartList.length > 0 ? (
                    <div className="input-group text-right col-md-3 col-12 my-2">
                      <NormalButton
                        buttonClass={"share w-100"}
                        resetbg={true}
                        className="col-12"
                        label="Delete Staff"
                        onClick={this.handleCommonDeleteStaffClick}
                      />
                    </div>
                  ) : null}
                  */}

            <div className="pb-1">
              <TableWrapper
                headerDetails={headerDetails}
                queryHandler={this.handlePagination}
                // pageMeta={pageMeta}
                // isEmpty={cartList.length === 0 ? true:false}
              >
                {cartList.length > 0
                  ? cartList.map((item, index) => {
                      console.log(item, "item");
                      return (
                        <tr key={index}>
                          <td>
                            <div
                              className={`d-flex align-items-center justify-content-center`}
                            >
                              <NormalCheckbox
                                onChange={(e) => this.handleCheckbox(e, item)}
                                name="selected"
                                checked={item.selected}
                                type="checkbox"
                              />
                            </div>
                          </td>

                          {(this.props.tokenDetails?.sharepackage && !item.is_td) && (
                            <td style={{ padding: "0.75rem 0" }}>
                              <div
                                className={`d-flex align-items-center justify-content-center`}
                              >
                                <img
                                  src={shareIcon}
                                  className="share-icon"
                                  onClick={() => this.handleShareIcon(item)}
                                />
                              </div>
                            </td>
                          )}

                          {this.props.tokenDetails?.showpriceincludegst && (
                            <td>
                              <div
                                className={`d-flex align-items-center justify-content-center`}
                              >
                                <NormalCheckbox
                                  onChange={(e) =>
                                    this.handleTaxCheckbox(e, item)
                                  }
                                  name="priceincludegst"
                                  checked={item.priceincludegst}
                                  type="checkbox"
                                />
                              </div>
                            </td>
                          )}
                          <td>
                            <div
                              className={`d-flex align-items-center justify-content-center ${
                                item.deposit < 0 ? "text-danger" : ""
                              } `}
                            >
                              {/* <div
                                className="col p-0 fs-19 cursor-pointer d-none"
                                onClick={() => this.handleEditCart(item)}
                              >
                                <span className="icon-edit"></span>
                              </div> */}
                              <div
                                className="col p-0 pr-1 fs-18 cursor-pointer"
                                onClick={() => this.handleDeleteCart(item)}
                              >
                                <span className="icon-delete"></span>
                              </div>
                              {item.itemtype == "PACKAGE" ? (
                                <div
                                  className="col p-0 fs-18 cursor-pointer"
                                  onClick={() => this.handleOpenPackage(item)}
                                >
                                  <img src={packageIcon} />
                                </div>
                              ) : null}
                            </div>
                          </td>
                          <td className="position-relative status-type">
                            <span className={``}></span>
                            <div
                              onClick={() => this.handleItemCourseClick(item)}
                              className={`d-flex cursor-pointer text-left ${
                                item.is_course || item.is_prepaid
                                  ? "text-primary"
                                  : ""
                              } ${item.deposit < 0 ? "text-danger" : ""}`}
                            >
                              {item.itemdesc}
                            </div>
                          </td>
                          <td style={{ maxWidth: "80px" }}>
                            <div className={`text-right numberpad-input`}>
                              {/* <div className="input-group"> */}
                              {/* <input
                                  style={{
                                    width: "45px",
                                    textAlign: "right",
                                  }}
                                  value={item.quantity}
                                  name="quantity"
                                  onChange={event =>
                                    this.handleQtyChange(event, item, index)
                                  }
                                  type={`number`}
                                  min={1}
                                  maxLength={5}
                                  className={`customer-name text-right`}
                                  disabled={
                                    item.is_tcm || item.is_td ? true : false
                                  }
                                /> */}
                              {/* <NormalInput
                                type="number"
                                value={item.quantity}
                                name="quantity"
                                onChange={(event) =>
                                  this.handleQtyChange(event, item, index)
                                }
                                className="col-12 p-1 text-right "
                                min={1}
                                maxLength={5}
                                disabled={
                                  item.is_tcm || item.is_td ? true : false
                                }
                              /> */}
                              {/* {(item.is_tcm || item.is_td) &&
                              !this.props.tokenDetails.autotdforalacarte ? (
                                <NormalInput
                                  type="number"
                                  value={item.quantity}
                                  name="quantity"
                                  onChange={(event) => {}}
                                  className="col-12 p-1 text-right "
                                  min={1}
                                  maxLength={5}
                                  disabled
                                />
                              ) : (
                                <NumPadKeyboard
                                  onChange={(value) => {
                                    console.log("value", value);
                                    this.handleQtyChange(
                                      { target: { value: value } },
                                      item,
                                      index
                                    );
                                  }}
                                  value={item.quantity}
                                  decimal={false}
                                />
                              )} */}
                              {console.log(
                                "checkin->",
                                item.is_tcm,
                                item.is_td,
                                this.props.tokenDetails.autotdforalacarte
                              )}
                              {item.is_tcm || item.is_td ? (
                                <NormalInput
                                  type="number"
                                  value={
                                    // item.duration_product === 1
                                    //   ? 1
                                    // :
                                    item.quantity
                                  }
                                  name="quantity"
                                  onChange={(event) => {}}
                                  className="col-12 p-1 text-right "
                                  min={1}
                                  //Yoonus change from 5 to 2 to prevent qty entry more than 100
                                  max={99}
                                  maxLength={2}
                                  disabled
                                />
                              ) : (
                                <>
                                  {this.props.tokenDetails.ipadkey ? (
                                    <NumPadKeyboard
                                      onChange={(value) => {
                                        console.log("value", value);
                                        this.handleQtyChange(
                                          { target: { value: value } },
                                          item,
                                          index
                                        );
                                      }}
                                      value={
                                        // item.duration_product === 1
                                        //   ? 1
                                        item.quantity
                                      }
                                      decimal={false}
                                    />
                                  ) : (
                                    <NormalInput
                                      type="number"
                                      value={
                                        // item.duration_product === 1
                                        //   ? 1
                                        item.quantity
                                      }
                                      name="quantity"
                                      onChange={(event) =>
                                        this.handleQtyChange(event, item, index)
                                      }
                                      className="col-12 p-1 text-right "
                                      min={1}
                                      //Yoonus changing maxlength from 5 to 2. qty not alow more than 99
                                      max={99}
                                      maxLength={2}
                                      disabled={
                                        item?.duration_product === 1 ||
                                        item?.package_hold
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </div>
                            {/* </div> */}
                          </td>
                          <td style={{ maxWidth: "80px" }}>
                            <div className={`text-right numberpad-input`}>
                              {item.is_unitprice ? (
                                // <NormalInput
                                //   type="number"
                                //   value={item.price}
                                //   name="price"
                                //   onChange={(e) =>
                                //     this.handleUnitPriceChange(e, item, index)
                                //   }
                                //   className="col-12 p-1 text-right"
                                //   disabled={
                                //     item.is_tcm || item.is_td ? true : false
                                //   }
                                // />
                                <>
                                  {item.is_tcm || item.is_td ? (
                                    <NormalInput
                                      type="number"
                                      value={item.price}
                                      name="price"
                                      onChange={(e) =>
                                        !item.is_td &&
                                        this.handleUnitPriceChange(
                                          e,
                                          item,
                                          index
                                        )
                                      }
                                      onClick={() => {
                                        console.log(item.is_course, "isCourse");
                                        if (item.is_course) {
                                          this.setState({
                                            editSelectedTdUnitPrice: true,

                                            selectedTdData: { item, index },
                                          });
                                        }
                                      }}
                                      className="col-12 p-1 text-right first"
                                      disabled={
                                        item?.duration_product === 1 ||
                                        item?.package_hold
                                      }
                                      // disabled={true}
                                    />
                                  ) : (
                                    <>
                                      {this.props.tokenDetails
                                        .autotdforalacarte ? (
                                        // <NumPadKeyboard
                                        //   onChange={(value) => {
                                        //     console.log("value", value);
                                        //     this.handleUnitPriceChange(
                                        //       { target: { value: value } },
                                        //       item,
                                        //       index
                                        //     );
                                        //   }}
                                        //   onClick={() => {
                                        //     this.setState({
                                        //       editSelectedTdUnitPrice: true,

                                        //       selectedTdData: { item, index },
                                        //     });
                                        //     console.log(
                                        //       this.state
                                        //         .editSelectedTdUnitPrice,
                                        //       "editSelect"
                                        //     );
                                        //   }}
                                        //   className="autotd"
                                        //   value={item.price}
                                        //   placeholder={"Unit Price"}
                                        // />
                                        <NormalInput
                                          type="number"
                                          value={item.price}
                                          name="price"
                                          onChange={(e) =>
                                            !item.is_td &&
                                            this.handleUnitPriceChange(
                                              e,
                                              item,
                                              index
                                            )
                                          }
                                          onClick={() => {
                                            if (item.is_course) {
                                              this.setState({
                                                editSelectedTdUnitPrice: true,

                                                selectedTdData: { item, index },
                                              });
                                            }
                                          }}
                                          className="col-12 p-1 text-right first"
                                          disabled={
                                            item?.duration_product === 1 ||
                                            item?.package_hold
                                          }
                                          // disabled={true}
                                        />
                                      ) : (
                                        <NormalInput
                                          type="number"
                                          value={item.price}
                                          name="price"
                                          onChange={(e) =>
                                            this.handleUnitPriceChange(
                                              e,
                                              item,
                                              index
                                            )
                                          }
                                          className="col-12 p-1 text-right  2nd "
                                          disabled={
                                            item?.duration_product === 1 ||
                                            item?.package_hold
                                          }
                                        />
                                      )}
                                    </>
                                  )}{" "}
                                </>
                              ) : (
                                <NormalInput
                                  type="number"
                                  value={item.price}
                                  name="price"
                                  onChange={(e) => {}}
                                  className="col-12 p-1 text-right"
                                  disabled={true}
                                />
                              )}
                            </div>
                          </td>

                          {/* <td style={{ maxWidth: "110px" }}>
                            <div className={`text-right numberpad-input`}>
                              {item.is_unitprice ? (
                                // <NormalInput
                                //   type="number"
                                //   value={item.price}
                                //   name="price"
                                //   onChange={(e) =>
                                //     this.handleUnitPriceChange(e, item, index)
                                //   }
                                //   className="col-12 p-1 text-right"
                                //   disabled={
                                //     item.is_tcm || item.is_td ? true : false
                                //   }
                                // />
                                <>
                                  {item.is_tcm || item.is_td ? (
                                    <NormalInput
                                      type="number"
                                      value={item.price}
                                      name="price"
                                      onChange={(e) => {}}
                                      className="col-12 p-1 text-right"
                                      disabled={true}
                                    />
                                  ) : (
                                    <>
                                      {this.props.tokenDetails.ipadkey ? (
                                        <NumPadKeyboard
                                          onChange={(value) => {
                                            console.log("value", value);
                                            this.handleUnitPriceChange(
                                              { target: { value: value } },
                                              item,
                                              index
                                            );
                                          }}
                                          value={item.price}
                                          placeholder={"Unit Price"}
                                        />
                                      ) : (
                                        <NormalInput
                                          type="number"
                                          value={item.price}
                                          name="price"
                                          onChange={(e) =>
                                            this.handleUnitPriceChange(
                                              e,
                                              item,
                                              index
                                            )
                                          }
                                          className="col-12 p-1 text-right"
                                        />
                                      )}
                                    </>
                                  )}{" "}
                                </>
                              ) : (
                                <NormalInput
                                  type="number"
                                  value={item.price}
                                  name="price"
                                  onChange={(e) => {}}
                                  className="col-12 p-1 text-right"
                                  disabled={true}
                                />
                              )}
                            </div>
                          </td> */}
                          <td>
                            <div
                              onClick={() =>
                                this.handleDiscountDetailClick(item)
                              }
                              className={`cursor-pointer text-right
                              ${
                                item.is_disc &&
                                !item.package_hold &&
                                !item.duration_product &&
                                (item.treatment_no === null ||
                                  Number(item.treatment_no) <= 0)
                                  ? "text-primary"
                                  : ""
                              }
                              ${item.deposit < 0 ? "text-danger" : ""} `}
                            >
                              {item.discount}
                            </div>
                          </td>
                          <td>
                            <div
                              className={`text-right ${
                                item.deposit < 0 ? "text-danger" : ""
                              } `}
                            >
                              {item.discount_price}
                            </div>
                          </td>
                          <td>
                            <div
                              className={`text-right ${
                                item.deposit < 0 ? "text-danger" : ""
                              } `}
                            >
                              {item.trans_amt}
                            </div>
                          </td>

                          {!this.props.tokenDetails.ipadkey && (
                            <td>
                              <div
                                className={`text-right ${
                                  item.deposit < 0 ? "text-danger" : ""
                                } `}
                              >
                                {item.deposit}
                              </div>
                            </td>
                          )}

                          <td>
                            <div
                              className={`text-left ${
                                item.deposit < 0 ? "text-danger" : ""
                              } `}
                            >
                              {item.sales_staff}
                            </div>
                          </td>
                          <td
                          //className={`cursor-pointer`}
                          // onClick={() => this.handleTreatmentDone(item)}
                          >
                            <div
                              className={`text-left
                              ${
                                item.is_tstaff && Number(item.quantity) == 1
                                  ? ""
                                  : ""
                              } 
                              ${item.deposit < 0 ? "text-danger" : ""} `}
                            >
                              {item.service_staff}
                            </div>
                          </td>
                          <td>
                            <div
                              className={`text-left ${
                                item.deposit < 0 ? "text-danger" : ""
                              } `}
                            >
                              {item.itemstatus_name ? item.itemstatus_name : ""}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </TableWrapper>
            </div>
            <div className="col-12 payment-section py-2 fs-12">
              <div className="row">
                <div className="col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5 ">
                  <div className="row">
                    <div className="col-6">{t("Subtotal")}</div>
                    <div className="col-6">
                      $ {cartData.subtotal ? cartData.subtotal : "0"}
                    </div>
                    <div className="col-6">{t("Discount ($)")}</div>
                    <div className="col-6">
                      $ {cartData.discount ? cartData.discount : "0"}
                    </div>
                    <div className="col-6">{t("Transac amount")}</div>
                    <div className="col-6">
                      $ {cartData.trans_amt ? cartData.trans_amt : "0"}
                    </div>
                    <div className="col-6">{t("Deposit")}</div>
                    <div className="col-6">
                      $ {cartData.deposit_amt ? cartData.deposit_amt : "0"}
                    </div>
                    <div className="col-6">{t("Balance")}</div>
                    <div className="col-6">
                      $ {cartData.balance ? cartData.balance : "0"}
                    </div>
                    <div className="col-6">{t("Outstanding")}</div>
                    <div className="col-6">
                      $ {cartData.outstanding ? cartData.outstanding : "0"}
                    </div>
                  </div>
                </div>
                <div className="col-sm-7 col-md-7 col-lg-7 col-xl-7">
                  <div className="row">
                    <div className="col-8 col-sm-6 col-md-8 col-lg-8 col-xl-6  h6 fw-700">
                      {t("Total Billing Amount")}
                    </div>
                    <div className="col-4 col-sm-6 col-md-4 col-lg-4 col-xl-6 text-left text-orenge h5 fw-600">
                      $
                      {cartData.billable_amount
                        ? cartData.billable_amount
                        : "0"}
                    </div>
                  </div>
                  <div className="row mb-1">
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-6 font-700 ">
                      {t("Deposit")}
                    </div>
                    <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-4">
                      {this.props.tokenDetails.ipadkey ? (
                        <NumPadKeyboard
                          onChange={this.handleDepositChange}
                          value={this.state.commonDeposit}
                          customClassName="col-12 p-1 text-right"
                          decimal={2}
                        />
                      ) : (
                        <NormalInput
                          type="number"
                          value={this.state.commonDeposit}
                          name="commonDeposit"
                          onChange={(e) =>
                            this.handleDepositChange(e.target.value)
                          }
                          className="col-12 p-1 text-right"
                        />
                      )}
                    </div>
                    {this.props.tokenDetails?.showpriceincludegst && (
                      <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                        <NormalCheckbox
                          onChange={(e) => this.handleDepositGst(e)}
                          name="depositPriceGst"
                          checked={this.state.depositPriceGst}
                          type="checkbox"
                        />
                      </div>
                    )}
                    {/* <div className="col-md-4 col-12 text-left fs-11">
                    <div className="d-flex flex-wrap">
                      <div className="">
                        <NormalCheckbox
                          checked={
                            this.state.is_selectDeposit == "amount"
                              ? true
                              : false
                          }
                          onChange={() => this.handleRadioCheckbox(`amount`)}
                          className="fs-12 m-1"
                          icon={false}
                          name={`toptoBottom`}
                        />
                        <span>{t("Top to bottom by Amount")}</span>
                      </div>
                      <div className="">
                        <NormalCheckbox
                          checked={
                            this.state.is_selectDeposit == "auto" ? true : false
                          }
                          onChange={() => this.handleRadioCheckbox(`auto`)}
                          className="fs-12 m-1"
                          name={`toptoBottom`}
                          icon={false}
                        />
                        <span>{t("Auto proportion for all lines")}</span>
                      </div>
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
              <div className="row justify-content-center p-2">
                <div className="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3  p-1">
                  <NormalButton
                    resetbg={true}
                    className="col-12"
                    label="Clear All"
                    onClick={() => this.handleClearAllConfirmation()}
                    leftIcon={clearAllIcon}
                  />
                </div>
                <div className="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3  p-1">
                  <NormalButton
                    mainbg={false}
                    className="col-12 submit-btn"
                    label="Checkout"
                    onClick={() => this.handleCheckout()}
                    leftIcon={checkoutIcon}
                  />
                </div>
                <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3  p-1">
                  <NormalButton
                    mainbgrev={true}
                    className="col-12"
                    label="Trac/Disc"
                    onClick={this.handleLoginConfirmationDialog}
                    leftIcon={TransactionIcon}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            switchCheckedOff
              ? `${
                  deviceWidthCheck <= 1199 ? "d-none" : "d-none d-lg-block"
                }  col-12 col-sm-4 col-md-4 col-lg-4 col-xl-5 pl-2 pr-0 `
              : `d-none`
          }
        >
          <Treatment
            handleCartCreated={this.handleCartCreated}
            cartData={cartList}
            handleCardItemCourseClick={(editCart) =>
              this.handleCardItemCourseClick(editCart)
            }
            handleCardPrepaidClick={(editCart) =>
              this.handleCardPrepaidClick(editCart)
            }
            custId={
              formFields && formFields.custId
                ? formFields.custId
                : basicApptDetail.custId
            }
            defaultStaffId={defaultStaff}
            cartId={cartId}            
          ></Treatment>
        </div>
        {visible ? (
          <div className="customerSearch-block">
            <div className="closeIconParent">
              <img
                onClick={() => this.setState({ visible: false })}
                className="close cursor-pointer close-flexEnd"
                src={closeIcon}
                alt=""
              />
            </div>
            <div className="d-flex mt-4 table table-header w-100 m-0">
              <div className="col-2">{t("Name")}</div>
              <div className="col-2">{t("Phone")}</div>
              <div className="col-1">{t("Site")}</div>
              <div className="col-2">{t("Cust Code")}</div>
              <div className="col-2">{t("Reference")}</div>
              <div className="col-3">{t("Email")}</div>
              <div className="col-1 d-none">{t("NRIC")}</div>
            </div>
            <div className="response-table w-100">
              {customerOption.length > 0 ? (
                customerOption.map((item, index) => {
                  return (
                    <div
                      className={`row m-0 table-body w-100 border py-2  ${
                        item.isoutlet_resrict ? "rowEnable" : "rowDisable"
                      }`}
                      onClick={() => {
                        this.props.tokenDetails.customeroutletrestrict &&
                        item.isoutlet_resrict
                          ? this.handleSelectCustomer(item)
                          : !this.props.tokenDetails.customeroutletrestrict
                          ? this.handleSelectCustomer(item)
                          : Toast({
                              type: "error",
                              message:
                                "This customer is not inside your outlet, Please request this customer",
                            });
                      }}
                      key={index}
                    >
                      <div className="col-2">{item.cust_name}</div>
                      <div className="col-2">{item.cust_phone2}</div>
                      <div className="col-1">{item.or_key}</div>
                      <div className="col-2">{item.cust_code}</div>
                      <div className="col-2">{item.cust_refer}</div>
                      <div className="col-3">{item.cust_email}</div>
                      <div className="col-1 d-none">{item.cust_nric}</div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center w-100">
                  {t("No Data are available")}
                </div>
              )}
            </div>
          </div>
        ) : null}
        <NormalModal
          className={"payment-modal"}
          style={{
            minWidth:
              deviceWidthCheck < 768
                ? "95%"
                : deviceWidthCheck >= 768 && deviceWidthCheck <= 992
                ? "95%"
                : "90%",
          }}
          modal={isOpenPayment}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          {console.log("sfgdfjhfghjfjgkjk", cartData)}
          <Payment
            cartData={cartData}
            id={basicApptDetail.custId}
            cartId={cartList.length > 0 ? cartList[0].cart_id : ""}
            handleModal={this.handleDialog}
          ></Payment>
        </NormalModal>

        <NormalModal
          className={"edit-cart-modal"}
          style={{ minWidth: "75%" }}
          modal={isOpenEditcart}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <EditCart id={editCart.id} handleModal={this.handleDialog}></EditCart>
        </NormalModal>
        <NormalModal
          className={"package-modal"}
          style={{ minWidth: "75%" }}
          modal={isOpenPackage}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <PackageCart
            id={editCart.id}
            handleModal={this.handleDialog}
          ></PackageCart>
        </NormalModal>
        <NormalModal
          className={"transaction-discount-update"}
          style={{ minWidth: "75%" }}
          modal={isOpenEditDisc}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          {/* <Discount discountFields={()=>{}} handleChange={()=>{}} handleSubmit={()=>{}}></Discount> */}
          {isOpenEditDisc ? (
            <EditDiscount
              id={cartList.length > 0 ? cartList[0].cart_id : ""}
              handleModal={this.handleDialog}
            ></EditDiscount>
          ) : (
            ""
          )}
        </NormalModal>
        <NormalModal
          className={"transaction-done-modal"}
          style={{ minWidth: "55%" }}
          modal={isOpenTreatmentDone}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <TreatmentDone
            id={cartId}
            cartId={editCart.id}
            handleModal={this.handleDialog}
          ></TreatmentDone>
        </NormalModal>
        {/* <NormalModal
          className={"select-category customer-select"}
          style={{ minWidth: "75%" }}
          modal={isOpenCustomer}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close"
            src={closeIcon}
            alt=""
          />
          <div className="row mt-2 mb-5 mx-3">
            <div className="col-12 pl-0 mb-3 fs-18 py-2">Select Customer</div>
            <div className="col-2 pl-0">Search</div>
            <div className="col-5">
              <input
                name="treatment"
                value={search}
                onChange={this.handleSearch}
                className="search m-0 p-0 px-3"
              />
            </div>
            <div className="col-3">
              <NormalButton
                buttonClass={"mx-2 p-0"}
                mainbg={true}
                className="confirm"
                label="Search"
                outline={false}
                onClick={() => this.search(this.state.search)}
              />
            </div>

            <div className="row mt-4 table-header w-100 m-0">
              <div className="col-3">Name</div>
              <div className="col-2">Phone</div>
              <div className="col-3">Cust Code</div>
              <div className="col-4">Email</div>
            </div>
            <div className="response-table w-100">
              {customerOption && customerOption.length > 0 ? (
                customerOption.map((item, index) => {
                  return (
                    <div
                      className="row m-0 table-body w-100"
                      onClick={() => this.handleSelectCustomer(item)}
                      key={index}
                    >
                      <div className="col-3">{item.cust_name}</div>
                      <div className="col-2">{item.cust_phone1}</div>
                      <div className="col-3">{item.cust_code}</div>
                      <div className="col-4">{item.cust_email}</div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center w-100">No Data are available</div>
              )}
            </div>
          </div>
        </NormalModal> */}
        <NormalModal
          className={"transaction-done-modal top-up-modal"}
          style={{ minWidth: "75%" }}
          modal={isOpenTopup}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <Topup
            id={cartId}
            cartId={editCart.id}
            handleModal={this.handleDialog}
          ></Topup>
        </NormalModal>
        <NormalModal
          className={"transaction-done-modal top-up-modal"}
          style={{ minWidth: "85%" }}
          modal={isOpenCombinedTopup}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <CombineTopup
            id={basicApptDetail.custId}
            handleModal={this.handleDialog}
          />
        </NormalModal>
        <NormalModal
          className={"payment-modal"}
          style={{ minWidth: "40%" }}
          modal={isOpenExchangePayment}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />

          <div className="fs-18 fw-700 mb-3 title">{t("Exchange Payment")}</div>
          <div className="col-12 pl-0 mb-2 fs-15 fw-500 py-1">
            {t("Extra Amount")} &nbsp;
            <span className="text-center text-orenge fs-18 font-500">
              {exchangeBalanceAmount}
            </span>
            &nbsp;{t("Need to Return to Customer")}
          </div>

          <div className="row">
            <div className="col-12">
              <label className="text-left text-black common-label-text ">
                {t("Remark")}
              </label>
              <div className="input-group myp-0">
                <NormalTextarea
                  value={exchangeRemark}
                  name="exchangeRemark"
                  onChange={this.exchangeRemarkChange}
                  className="custome-name px-3 p-0 col-12"
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-around pt-3">
            <NormalButton
              mainbg={true}
              className="col-12 fs-13  "
              label="Return Cash"
              onClick={() => {
                this.handleExchangeLessthanZero("Cash");
              }}
            />

            <NormalButton
              mainbg={true}
              className="col-12 fs-13 "
              label="Issue Credit Notes"
              onClick={() => {
                this.handleExchangeLessthanZero("Credit");
              }}
            />

            <NormalButton
              mainbg={true}
              className="col-12 fs-13 "
              label="Forfeit [Cash = 0]"
              onClick={() => {
                this.handleExchangeLessthanZero("Forfeit");
              }}
            />
          </div>
        </NormalModal>
        <NormalModal
          className={"transaction-done-modal top-up-modal"}
          style={{ minWidth: "75%" }}
          modal={isOpenProductDetail}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <ProductDetailsPopup
            id={cartId}
            cartId={editCart.id}
            handleModal={this.handleDialog}
          ></ProductDetailsPopup>
        </NormalModal>
        {console.log("deviceWidthCheck", deviceWidthCheck)}
        <NormalModal
          className={"transaction-done-modal top-up-modal"}
          style={{
            minWidth:
              deviceWidthCheck < 768
                ? "95%"
                : deviceWidthCheck >= 768 && deviceWidthCheck <= 992
                ? "90%"
                : "80%",
          }}
          modal={isOpenCourseDetail}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleDialogCoursepopup}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <CoursePopup
            id={cartId}
            cartId={editCart.id}
            handleModal={this.handleDialog}
            itemData={editCart}
          ></CoursePopup>
        </NormalModal>
        <NormalModal
          className={"transaction-done-modal top-up-modal"}
          style={{
            minWidth:
              deviceWidthCheck < 768
                ? "95%"
                : deviceWidthCheck >= 768 && deviceWidthCheck <= 992
                ? "90%"
                : "80%",
          }}
          modal={isOpenPrepaidDetail}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <PrepaidPopup
            id={cartId}
            cartId={editCart.id}
            handleModal={this.handleDialog}
          ></PrepaidPopup>
        </NormalModal>

        <NormalModal
          className={"transaction-done-modal top-up-modal"}
          style={{ minWidth: deviceWidthCheck > 768 ? "75%" : "90%" }}
          modal={isOpenDiscountDetail}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <ItemDiscountPopup
            id={cartId}
            cartId={editCart.id}
            handleModal={this.handleDialog}
          ></ItemDiscountPopup>
        </NormalModal>
        <NormalModal
          className={"transaction-done-modal top-up-modal"}
          style={{ minWidth: "75%" }}
          modal={isOpenItemStatusDetail}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <ItemStatusPopup
            id={cartId}
            cartId={editCart.id}
            handleModal={this.handleDialog}
          ></ItemStatusPopup>
        </NormalModal>
        <NormalModal
          className={"transaction-done-modal top-up-modal"}
          style={{ minWidth: "75%" }}
          modal={isOpenStaffSelectionDetail}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <StaffSelectionPopup
            id={cartId}
            cartId={editCart.id}
            handleModal={this.handleDialog}
          ></StaffSelectionPopup>
        </NormalModal>
        <NormalModal
          className={"transaction-done-reversal"}
          style={{ minWidth: "30%" }}
          modal={isHandleConfirmationDialog}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleClearAllConfirmation}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <div className="row">
            <div className="d-flex flex-wrap">
              <div className="col-12">
                <h4>{t("Confirmation")}</h4>
              </div>
              <div className="col-12 mb-2">
                <p>{t("Are you sure want to continue")} ?</p>
              </div>
              <div className="row p-3">
                <div className="col-6">
                  <NormalButton
                    label="Confirm"
                    mainbg={true}
                    name="clearallconfirm"
                    className={`w-100 col-12`}
                    onClick={this.handleClearAllCart}
                  />
                </div>
                <div className="col-6">
                  <NormalButton
                    label="Cancel"
                    resetbg={true}
                    name="clearallCancel"
                    className={`w-100 col-12`}
                    onClick={this.handleClearAllConfirmation}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
        <NormalModal
          className={"d-flex justify-content-center"}
          style={{ minWidth: "20%" }}
          modal={isLoginConfirmation}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleLoginConfirmationDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <CredentialConfirmation
            handleLoginSubmit={(user, pass) =>
              this.handleauthentication(user, pass)
            }
          />
        </NormalModal>

        <NormalModal
          className={"d-flex justify-content-center"}
          style={{ minWidth: "20%" }}
          modal={isExchangeConfirmation}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleExchangeConfirmationDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <CredentialConfirmation
            handleLoginSubmit={(user, pass) =>
              this.handleExchangeAuthentication(user, pass)
            }
          />
        </NormalModal>

        <NormalModal
          className={"d-flex justify-content-center"}
          style={{ minWidth: "25%" }}
          modal={showBirthdayPopup}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleBirthdayPopup}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <div className="px-3 pt-3 ">
            <h6>{formFields.custName} has Birthday this month!</h6>
            <h6>Birthdate : {formFields.cust_dob}</h6>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  d-flex justify-content-center">
              <div className="col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4  p-1 ">
                <NormalButton
                  mainbg={false}
                  className="col-12  submit-btn"
                  label="Ok"
                  onClick={() => this.handleBirthdayPopup()}
                />
              </div>
            </div>
          </div>
        </NormalModal>

        <NormalModal
          className={"d-flex justify-content-center"}
          style={{ minWidth: "25%" }}
          modal={showCustomerClassExpiredPopup}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleCustomerClassExpiredPopup}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <div className="px-3 pt-3 ">
            <h6>Customer Name: {formFields.custName}</h6>
            <h6>Customer Class: {formFields.cust_class}</h6>
            <h6>Class Expiry Date: {formFields.classexpiry}</h6>
            <h6></h6>
            {formFields.classexpirystatus === 1 ? (
              <h6 style={{ color: "#DC143C" }}>* Reminder: This customer's membership expires today!</h6>
            ) : (
              formFields.classexpirystatus === 2
              ? <h6 style={{ color: "#DC143C" }}>* Alert: This customer's membership is expired!</h6>
              : <h6  style={{ color: "#DC143C" }}>* Reminder: This customer's membership will expire in {formFields.classexpirystatus} days!</h6>
            )}

            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  d-flex justify-content-center">
              <div className="col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4  p-1 ">
                <NormalButton
                  mainbg={false}
                  className="col-12 submit-btn"
                  label="Ok"
                  onClick={() => this.handleCustomerClassExpiredPopup()}
                />
              </div>
            </div>
          </div>
        </NormalModal>

        <NormalModal
          className={"d-flex justify-content-center"}
          style={{ minWidth: "20%" }}
          modal={isStaffLoginConfirmation}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleStaffLoginConfirmationDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <CredentialConfirmation
            handleLoginSubmit={(user, pass) =>
              this.handleCommonApplyStaff(user, pass)
            }
          />
        </NormalModal>

        {/* <NormalModal
          className={"stock-memo-staff-listing"}
          style={{ minWidth: "60%" }}
          modal={staffCommonListPopup}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleCommonCreateEmployeePopup}
            className="close"
            src={closeIcon}
            alt=""
          />
          <StaffList
            staffList={staffList}
            meta={meta}
            handleNext={() => this.handleNext()}
            handleBack={() => this.handleBack()}
            handleSelectedStaff={item => this.handleCommonSelectedStaff(item)}
          />
        </NormalModal>

        <NormalModal
          className={"stock-memo-staff-listing"}
          style={{ minWidth: "60%" }}
          modal={staffDeleteCommonListPopup}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleCommonDeleteEmployeePopup}
            className="close"
            src={closeIcon}
            alt=""
          />
          <StaffList
            staffList={availableStaffList}
            meta={availstaffmeta}
            handleNext={() => this.handleavailStaffNext()}
            handleBack={() => this.handleavailStaffBack()}
            handleSelectedStaff={item =>
              this.handleCommonDeleteSelectedStaff(item)
            }
          />
        </NormalModal> */}
        {editSelectedTdUnitPrice && (
          // <Modal isOpen={this.state.editSelectedTdUnitPrice}>
          //   <span style={{ color: "#ffff" }}>
          //     {" "}
          //     close {this.handleCloseDialog}
          //   </span>

          //   <img
          //     onClick={this.handleCloseDialog}
          //     className="CloseiconImg"
          //     src={closeIcon}
          //     alt=""
          //   />
          //   <ModalBody>
          //     {/* {JSON.stringify(this.state.selectedTdData)} */}

          //     <div>
          //       <span>
          //         Adjust the Service price of{" "}
          //         {this.state.selectedTdData.item.itemdesc}
          //       </span>
          //     </div>
          //     <br />

          //     <div
          //       style={{
          //         display: "flex",
          //         justifyContent: "space-between",
          //         marginLeft: "0px",
          //       }}
          //     >
          //       <div>
          //         <div>sno </div>
          //         <div>{this.state.selectedTdData.index + 1}</div>
          //       </div>
          //       <div>
          //         <div>qty </div>
          //         <div> {this.state.selectedTdData.item.quantity}</div>
          //       </div>
          //       <div>
          //         <div>price</div>
          //         <div style={{ maxWidth: 80 }}>
          //           <NormalInput
          //             type="number"
          //             value={this.state.selectedTdData.item.price}
          //             name="price"
          //             onChange={(e) => {
          //               this.setState({
          //                 selectedTdData: {
          //                   ...this.state.selectedTdData,
          //                   item: {
          //                     ...this.state.selectedTdData.item,
          //                     price: e.target.value,
          //                   },
          //                 },
          //               });
          //             }}
          //             className="col-12 p-1 text-right first"
          //             // disabled={true}
          //           />
          //         </div>
          //       </div>
          //       <div>
          //         <button
          //           style={{ width: 75, borderRadius: 5, marginTop: 20 }}
          //           onClick={() => {
          //             this.handleUnitPriceChange(
          //               {
          //                 target: {
          //                   value: this.state.selectedTdData.item.price,
          //                 },
          //               },
          //               this.state.selectedTdData.item,
          //               this.state.selectedTdData.index
          //             );
          //             this.setState({
          //               editSelectedTdUnitPrice: false,
          //             });
          //           }}
          //         >
          //           cart
          //         </button>
          //       </div>
          //     </div>
          //   </ModalBody>
          // </Modal>

          <NormalModal
            className={"edit-cart-modal"}
            style={{ minWidth: "40%" }}
            modal={editSelectedTdUnitPrice}
            handleModal={this.handleCloseDialog}
          >
            <img
              onClick={this.handleCloseDialog}
              className="close cursor-pointer"
              src={closeIcon}
              alt=""
            />

            {/* {JSON.stringify(this.state.selectedTdData)} */}

            <div>
              <span>
                Adjust the Service price of{" "}
                {this.state.selectedTdData.item.itemdesc}
              </span>
            </div>
            <br />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginLeft: "0px",
              }}
            >
              <div>
                <div>sno </div>
                <div>{this.state.selectedTdData.index + 1}</div>
              </div>
              <div>
                <div>qty </div>
                <div> {this.state.selectedTdData.item.quantity}</div>
              </div>
              <div>
                <div>price</div>
                <div style={{ maxWidth: 80 }}>
                  <NormalInput
                    type="number"
                    value={this.state.selectedTdData.item.price}
                    name="price"
                    onChange={(e) => {
                      this.setState({
                        selectedTdData: {
                          ...this.state.selectedTdData,
                          item: {
                            ...this.state.selectedTdData.item,
                            price: e.target.value,
                          },
                        },
                      });
                    }}
                    className="col-12 p-1 text-right first"
                    // disabled={true}
                  />
                </div>
              </div>
              <div>
                {/* <button
                  style={{ width: 75, borderRadius: 5, marginTop: 20 }}
                  onClick={() => {
                    this.handleUnitPriceChange(
                      {
                        target: {
                          value: this.state.selectedTdData.item.price,
                        },
                      },
                      this.state.selectedTdData.item,
                      this.state.selectedTdData.index
                    );
                    this.setState({
                      editSelectedTdUnitPrice: false,
                    });
                  }}
                >
                  cart
                </button> */}
                <NormalButton
                  mainbg={false}
                  className="col-12 submit-btn mt-3"
                  label="Cart"
                  onClick={() => {
                    this.handleUnitPriceChange(
                      {
                        target: {
                          value: this.state.selectedTdData.item.price,
                        },
                      },
                      this.state.selectedTdData.item,
                      this.state.selectedTdData.index
                    );
                    this.setState({
                      editSelectedTdUnitPrice: false,
                    });
                  }}
                  leftIcon={checkoutIcon}
                />
              </div>
            </div>
          </NormalModal>
        )}
        {/* {isCreateAppointment && ( */}
        <NormalModal
          className="col-12 col-md-12 col-sm-12"
          style={{
            minWidth:
              deviceWidth < 768
                ? "95%"
                : deviceWidth >= 768 && deviceWidth <= 1200
                ? "95%"
                : "80%",
            minHeight: "90%",
          }}
          modal={isOpenModal}
          handleModal={this.handleAppointmentClose}
        >
          <div className="row">
            <div className=" col-md-12 col-12 appointment-box appointment-col">
              <div className="appointment">
                <div className="appointment-holder">
                  <StudioATreatment
                    cartId={cartId}
                    apptId={appointmentId}
                    customerId={this.state.formFields.custId}
                    handleCloseDialog={this.handleAppointmentClose}
                    handleOpenPayment={this.handleOpenPayment}
                  ></StudioATreatment>
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
        {/* )} */}

        <NormalModal
          className={"edit-cart-modal"}
          style={{ minWidth: "75%" }}
          modal={isSharePopup}
          handleModal={this.handleShareDialog}
        >
          <img
            onClick={this.handleShareDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <ShareModal
            selectedPackage={selectedPackage}
            cartList={cartList}
            handleClose={this.handleShareDialog}
          />
        </NormalModal>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selected_cstomer: state.common.selected_cstomer,
  basicApptDetail: state.appointment.basicApptDetail,
  selectedCart: state.common.selectedCart,
  tokenDetails: state.authStore.tokenDetails,
  treatmentPageTrack: state.treatmentStore.treatmentPageTrack,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // getCustomer,
      getCommonApi,
      updateForm,
      commonDeleteApi,
      commonPatchApi,
      commonCreateApi,
      commonUpdateApi,
      getTreatementPageTrack,
    },
    dispatch
  );
};

export const CartNew = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(CartNewClass)
);